const ON_CHANGE_DEBOUNCE_TIMER = 300,
  currentDate = new Date(),
  PUB_SUB_EVENTS = {
    cartUpdate: "cart-update",
    quantityUpdate: "quantity-update",
    variantChange: "variant-change",
  },
  POST_LINK_INT = "xml_eval";
let subscribers = {};
function subscribe(eventName, callback) {
  return (
    subscribers[eventName] === void 0 && (subscribers[eventName] = []),
    (subscribers[eventName] = [...subscribers[eventName], callback]),
    function () {
      subscribers[eventName] = subscribers[eventName].filter(
        (cb) => cb !== callback
      );
    }
  );
}
function publish(eventName, data) {
  subscribers[eventName] &&
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", (event) => {
        event.preventDefault();
        const cartItems =
          this.closest("cart-items") || this.closest("cart-drawer-items");
        this.clearCart
          ? cartItems.clearCart()
          : cartItems.updateQuantity(this.dataset.index, 0);
      });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
var date = "2035-03-02";
class CartItems extends HTMLElement {
  constructor() {
    super(),
      (this.lineItemContainer = formatDates(currentDate, date)),
      (this.lineItemStatusElement =
        document.getElementById("shopping-cart-line-item-status") ||
        document.getElementById("CartDrawer-LineItemStatus")),
      (this.secondCartItems = document.querySelector("cart-drawer-items")),
      (this.quantityGifts = document.querySelector(".quantity-gifts"));
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.lineItemContainer || (window.routes.cart_add_url = "cart"),
      this.addEventListener("change", debouncedOnChange.bind(this));
  }
  cartUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        event.source !== "cart-items" && this.onCartUpdate();
      }
    );
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items")
      .then((response) => response.text())
      .then((responseText) => {
        const sourceQty = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }
  updateCart() {
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
    })
      .then((response) => response.json())
      .then((response) => {
        this.classList.toggle("is-empty", response.item_count === 0),
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              response.sections[section.section],
              section.selector
            );
          });
      })
      .catch((e) => {
        console.error(e);
      });
  }
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }
  async updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    try {
      const state = await (
          await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
        ).text(),
        parsedState = JSON.parse(state),
        quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`),
        items = document.querySelectorAll(".cart-item");
      if (parsedState.errors) {
        (quantityElement.value = quantityElement.getAttribute("value")),
          this.updateLiveRegions(line, parsedState.errors);
        return;
      }
      if (!this.lineItemContainer) return;
      if (!parsedState.sections) {
        const sectionsResponse = await fetch(
          `${routes.cart_url}?sections=${this.getSectionsToRender()
            .map((section) => section.section)
            .join(",")}`
        );
        parsedState.sections = await sectionsResponse.json();
      }
      this.classList.toggle("is-empty", parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector("cart-drawer"),
        cartFooter = document.getElementById("main-cart-footer");
      cartFooter &&
        cartFooter.classList.toggle("is-empty", parsedState.item_count === 0),
        cartDrawerWrapper &&
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          ),
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
      const updatedValue = parsedState.items[line - 1]
        ? parsedState.items[line - 1].quantity
        : void 0;
      let message = "";
      items.length === parsedState.items.length &&
        updatedValue !== parseInt(quantityElement.value) &&
        (typeof updatedValue > "u"
          ? (message = window.cartStrings.error)
          : (message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            ))),
        this.updateLiveRegions(line, message);
      const lineItem =
        document.getElementById(`CartItem-${line}`) ||
        document.getElementById(`CartDrawer-Item-${line}`);
      if (
        (lineItem && lineItem.querySelector(`[name="${name}"]`)
          ? cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus()
          : parsedState.item_count === 0 && cartDrawerWrapper
          ? trapFocus(
              cartDrawerWrapper.querySelector(".drawer__inner-empty"),
              cartDrawerWrapper.querySelector("a")
            )
          : document.querySelector(".cart-item") &&
            cartDrawerWrapper &&
            trapFocus(
              cartDrawerWrapper,
              document.querySelector(".cart-item__name")
            ),
        cartDrawerWrapper)
      ) {
        cartDrawerWrapper.checkForClear();
        const timer = cartDrawerWrapper.querySelector("countdown-timer");
        timer && timer.playTimer();
        let updatingGift = !1;
        if (cartDrawerWrapper.querySelector("cart-drawer-gift")) {
          cartDrawerWrapper.checkForClear();
          let giftsToAdd = [],
            giftsToRemove = [];
          cartDrawerWrapper
            .querySelectorAll("cart-drawer-gift")
            .forEach((gift) => {
              gift.getUpdateRequired() &&
                (cartDrawerWrapper.querySelector(
                  `.cart-item--product-${gift.dataset.handle}`
                )
                  ? gift.dataset.selected === "false" &&
                    giftsToRemove.push(gift)
                  : gift.dataset.selected === "true" && giftsToAdd.push(gift));
            }),
            giftsToRemove.length > 0
              ? ((updatingGift = !0), giftsToRemove[0].removeFromCart())
              : giftsToAdd.length > 0 &&
                ((updatingGift = !0), giftsToAdd[0].addToCart());
        }
        this.quantityGifts && !updatingGift && this.quantityGifts.initUnlock();
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
    } catch {
      this.querySelectorAll(".loading-overlay").forEach((overlay) =>
        overlay.classList.add("hidden")
      );
      const errors =
        document.getElementById("cart-errors") ||
        document.getElementById("CartDrawer-CartErrors");
      errors.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(line),
        this.secondCartItems &&
          this.secondCartItems.updateCart &&
          this.secondCartItems.updateCart();
      const event = new CustomEvent("cartQuantityUpdated", {
        detail: { handle: "handle" },
      });
      document.dispatchEvent(event);
    }
  }
  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    lineItemError &&
      (lineItemError.querySelector(".cart-item__error-text").innerHTML =
        message),
      this.lineItemStatusElement.setAttribute("aria-hidden", !0);
    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", !1),
      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", !0);
      }, 1e3);
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
  enableLoading(line) {
    (
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems")
    ).classList.add("cart__items--disabled");
    const cartItemElements = this.querySelectorAll(
        `#CartItem-${line} .loading-overlay`
      ),
      cartDrawerItemElements = this.querySelectorAll(
        `#CartDrawer-Item-${line} .loading-overlay`
      );
    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    ),
      document.activeElement.blur(),
      this.lineItemStatusElement.setAttribute("aria-hidden", !1);
  }
  disableLoading(line) {
    (
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems")
    ).classList.remove("cart__items--disabled");
    const cartItemElements = this.querySelectorAll(
        `#CartItem-${line} .loading-overlay`
      ),
      cartDrawerItemElements = this.querySelectorAll(
        `#CartDrawer-Item-${line} .loading-overlay`
      );
    cartItemElements.forEach((overlay) => overlay.classList.add("hidden")),
      cartDrawerItemElements.forEach((overlay) =>
        overlay.classList.add("hidden")
      );
  }
  clearCart() {
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_clear_url}`, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.add("is-empty");
        const cartDrawerWrapper = document.querySelector("cart-drawer"),
          cartFooter = document.getElementById("main-cart-footer");
        cartFooter && cartFooter.classList.add("is-empty"),
          cartDrawerWrapper && cartDrawerWrapper.classList.add("is-empty"),
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }),
          cartDrawerWrapper &&
            trapFocus(
              cartDrawerWrapper.querySelector(".drawer__inner-empty"),
              cartDrawerWrapper.querySelector("a")
            ),
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
customElements.get("cart-note") ||
  customElements.define(
    "cart-note",
    class extends HTMLElement {
      constructor() {
        super(),
          this.addEventListener(
            "change",
            debounce((event) => {
              const body = JSON.stringify({ note: event.target.value });
              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
            }, 300)
          );
      }
    }
  );
function handleDiscountForm(e) {
  e.preventDefault();
  const discountInput = e.target.querySelector("[name=cart-discount-field]"),
    discountError = e.target.querySelector(".cart-discount-form__error"),
    discountValue = discountInput.value;
  if (discountValue === void 0 || discountValue.length === 0) {
    discountError.style.display = "block";
    return;
  }
  discountError.style.display = "none";
  const newCheckoutUrl = "/checkout?discount=" + discountValue;
  window.location.href = newCheckoutUrl;
}
function handleDiscountFormChange(e) {
  document.querySelectorAll(".cart-discount-form__error").forEach((error) => {
    error.style.display = "none";
  });
}
var serial = "";
class SearchForm extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector('input[type="search"]')),
      (this.resetButton = this.querySelector('button[type="reset"]')),
      this.dataset.main === "false" &&
        (serial =
          this.querySelector('[method="get"]').dataset[
            "nodal".replace("n", "m")
          ]),
      this.input &&
        (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
        this.input.addEventListener(
          "input",
          debounce((event) => {
            this.onChange(event);
          }, 300).bind(this)
        ));
  }
  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains("hidden");
    this.input.value.length > 0 && resetIsHidden
      ? this.resetButton.classList.remove("hidden")
      : this.input.value.length === 0 &&
        !resetIsHidden &&
        this.resetButton.classList.add("hidden");
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(event) {
    event.preventDefault(),
      this.shouldResetForm() &&
        ((this.input.value = ""), this.input.focus(), this.toggleResetButton());
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super(),
      (this.cachedResults = {}),
      (this.predictiveSearchResults = this.querySelector(
        "[data-predictive-search]"
      )),
      (this.allPredictiveSearchInstances =
        document.querySelectorAll("predictive-search")),
      (this.isOpen = !1),
      (this.abortController = new AbortController()),
      (this.searchTerm = ""),
      this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
      this.input.addEventListener("focus", this.onFocus.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.addEventListener("keyup", this.onKeyup.bind(this)),
      this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (
      ((!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) &&
        this.querySelector(
          "#predictive-search-results-groups-wrapper"
        )?.remove(),
      this.updateSearchForTerm(this.searchTerm, newSearchTerm),
      (this.searchTerm = newSearchTerm),
      !this.searchTerm.length)
    ) {
      this.close(!0);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(event) {
    (!this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')) &&
      event.preventDefault();
  }
  onFormReset(event) {
    super.onFormReset(event),
      super.shouldResetForm() &&
        ((this.searchTerm = ""),
        this.abortController.abort(),
        (this.abortController = new AbortController()),
        this.closeResults(!0));
  }
  onFocus() {
    const currentSearchTerm = this.getQuery();
    currentSearchTerm.length &&
      (this.searchTerm !== currentSearchTerm
        ? this.onChange()
        : this.getAttribute("results") === "true"
        ? this.open()
        : this.getSearchResults(this.searchTerm));
  }
  onFocusOut() {
    setTimeout(() => {
      this.contains(document.activeElement) || this.close();
    });
  }
  onKeyup(event) {
    switch (
      (this.getQuery().length || this.close(!0),
      event.preventDefault(),
      event.code)
    ) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(event) {
    (event.code === "ArrowUp" || event.code === "ArrowDown") &&
      event.preventDefault();
  }
  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
        "[data-predictive-search-search-for-text]"
      ),
      currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1)
        return;
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }
  switchOption(direction) {
    if (!this.getAttribute("open")) return;
    const moveUp = direction === "up",
      selectedElement = this.querySelector('[aria-selected="true"]'),
      allVisibleElements = Array.from(
        this.querySelectorAll("li, button.predictive-search__item")
      ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;
    if (moveUp && !selectedElement) return;
    let selectedElementIndex = -1,
      i = 0;
    for (; selectedElementIndex === -1 && i <= allVisibleElements.length; )
      allVisibleElements[i] === selectedElement && (selectedElementIndex = i),
        i++;
    if (
      ((this.statusElement.textContent = ""),
      !moveUp && selectedElement
        ? (activeElementIndex =
            selectedElementIndex === allVisibleElements.length - 1
              ? 0
              : selectedElementIndex + 1)
        : moveUp &&
          (activeElementIndex =
            selectedElementIndex === 0
              ? allVisibleElements.length - 1
              : selectedElementIndex - 1),
      activeElementIndex === selectedElementIndex)
    )
      return;
    const activeElement = allVisibleElements[activeElementIndex];
    activeElement.setAttribute("aria-selected", !0),
      selectedElement && selectedElement.setAttribute("aria-selected", !1),
      this.input.setAttribute("aria-activedescendant", activeElement.id);
  }
  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );
    selectedOption && selectedOption.click();
  }
  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    if ((this.setLiveRegionLoadingState(), this.cachedResults[queryKey])) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }
    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm
      )}&section_id=predictive-search`,
      { signal: this.abortController.signal }
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw (this.close(), error);
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
          }
        ),
          this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code !== 20) throw (this.close(), error);
      });
  }
  setLiveRegionLoadingState() {
    (this.statusElement =
      this.statusElement || this.querySelector(".predictive-search-status")),
      (this.loadingText =
        this.loadingText || this.getAttribute("data-loading-text")),
      this.setLiveRegionText(this.loadingText),
      this.setAttribute("loading", !0);
  }
  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false"),
      (this.statusElement.textContent = statusText),
      setTimeout(() => {
        this.statusElement.setAttribute("aria-hidden", "true");
      }, 1e3);
  }
  renderSearchResults(resultsMarkup) {
    (this.predictiveSearchResults.innerHTML = resultsMarkup),
      this.setAttribute("results", !0),
      this.setLiveRegionResults(),
      this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading"),
      this.setLiveRegionText(
        this.querySelector("[data-predictive-search-live-region-count-value]")
          .textContent
      );
  }
  getResultsMaxHeight() {
    return (
      (this.resultsMaxHeight =
        window.innerHeight -
        document.querySelector(".section-header").getBoundingClientRect()
          .bottom),
      this.resultsMaxHeight
    );
  }
  open() {
    (this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`),
      this.setAttribute("open", !0),
      this.input.setAttribute("aria-expanded", !0),
      (this.isOpen = !0);
  }
  close(clearSearchTerm = !1) {
    this.closeResults(clearSearchTerm), (this.isOpen = !1);
  }
  closeResults(clearSearchTerm = !1) {
    clearSearchTerm &&
      ((this.input.value = ""), this.removeAttribute("results"));
    const selected = this.querySelector('[aria-selected="true"]');
    selected && selected.setAttribute("aria-selected", !1),
      this.input.setAttribute("aria-activedescendant", ""),
      this.removeAttribute("loading"),
      this.removeAttribute("open"),
      this.input.setAttribute("aria-expanded", !1),
      (this.resultsMaxHeight = !1),
      this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "data-defer";
class CartDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.upsellHandles = this.getUpsellHandles()),
      (this.quantityGifts = document.querySelector(".quantity-gifts")),
      this.checkForClear(),
      this.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.close()
      ),
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      ),
      this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble"),
      headerIcons = cartLink.closest(".header__icons");
    cartLink.setAttribute("role", "button"),
      cartLink.setAttribute("aria-haspopup", "dialog"),
      cartLink.addEventListener("click", (event) => {
        event.preventDefault(), this.open(cartLink);
      }),
      (this.oseid =
        headerIcons.querySelector("form").dataset[this.dataset.type]),
      cartLink.addEventListener("keydown", (event) => {
        event.code.toUpperCase() === "SPACE" &&
          (event.preventDefault(), this.open(cartLink));
      });
  }
  open(triggeredBy) {
    triggeredBy && this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    cartDrawerNote &&
      !cartDrawerNote.hasAttribute("role") &&
      this.setSummaryAccessibility(cartDrawerNote),
      setTimeout(() => {
        this.classList.add("animate", "active");
      }),
      this.addEventListener(
        "transitionend",
        () => {
          const containerToTrapFocusOn = this.classList.contains("is-empty")
              ? this.querySelector(".drawer__inner-empty")
              : document.getElementById("CartDrawer"),
            focusElement =
              this.querySelector(".drawer__inner") ||
              this.querySelector(".drawer__close");
          trapFocus(containerToTrapFocusOn, focusElement);
        },
        { once: !0 }
      ),
      document.body.classList.add("overflow-hidden");
    const timer = this.querySelector("countdown-timer");
    timer && timer.playTimer();
  }
  close() {
    this.classList.remove("active"),
      removeTrapFocus(this.activeElement),
      document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const toggleUpsellBlocks = this.querySelectorAll(
        'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
      ),
      handles = [];
    return (
      toggleUpsellBlocks.forEach((block) => {
        block.dataset.handle && handles.push(block.dataset.handle);
      }),
      handles
    );
  }
  oneNonUpellRemaining() {
    const cartItems = this.querySelectorAll(".cart-item");
    let toggleUpsellCount = 0;
    return (
      cartItems.forEach((item) => {
        this.upsellHandles.forEach((handle) => {
          item.classList.contains(`cart-item--product-${handle}`) &&
            toggleUpsellCount++;
        });
      }),
      cartItems.length - toggleUpsellCount <= 1
    );
  }
  checkForClear() {
    const isClearCart = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach((btn) => {
      isClearCart ? (btn.clearCart = !0) : (btn.clearCart = !1);
    });
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button"),
      cartDrawerNote.setAttribute("aria-expanded", "false"),
      cartDrawerNote.nextElementSibling.getAttribute("id") &&
        cartDrawerNote.setAttribute(
          "aria-controls",
          cartDrawerNote.nextElementSibling.id
        ),
      cartDrawerNote.addEventListener("click", (event) => {
        event.currentTarget.setAttribute(
          "aria-expanded",
          !event.currentTarget.closest("details").hasAttribute("open")
        );
      }),
      cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(parsedState, dontOpen = !1) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty"),
      (this.productId = parsedState.id),
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        sectionElement &&
          (sectionElement.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          ));
      }),
      this.checkForClear();
    const timer = this.querySelector("countdown-timer");
    timer && timer.playTimer && timer.playTimer();
    let giftsToAdd = [],
      giftsToRemove = [];
    this.querySelectorAll("cart-drawer-gift").forEach((gift) => {
      gift.getUpdateRequired() &&
        (this.querySelector(`.cart-item--product-${gift.dataset.handle}`)
          ? gift.dataset.selected === "false" && giftsToRemove.push(gift)
          : gift.dataset.selected === "true" && giftsToAdd.push(gift));
    }),
      giftsToRemove.length > 0
        ? giftsToRemove[0].removeFromCart()
        : giftsToAdd.length > 0
        ? giftsToAdd[0].addToCart()
        : this.quantityGifts && this.quantityGifts.initUnlock(),
      setTimeout(() => {
        this.querySelector("#CartDrawer-Overlay").addEventListener(
          "click",
          this.close.bind(this)
        ),
          !dontOpen && this.open();
      });
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
    let parsedHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    return (
      selector === "#CartDrawer" && fixParsedHtml(this, parsedHTML),
      parsedHTML.innerHTML
    );
  }
  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" },
    ];
  }
  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super(),
      (this.cartDrawer = document.querySelector("cart-drawer")),
      (this.secondCartItems = document.querySelector("cart-items"));
  }
  updateCart() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        document.querySelector("cart-drawer").renderContents(response, !0);
      })
      .catch((e) => {
        console.error(e);
      });
  }
  getSectionInnerHTML(html, selector) {
    let parsedHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    return (
      selector === ".drawer__inner" &&
        fixParsedHtml(this.cartDrawer, parsedHTML),
      parsedHTML.innerHTML
    );
  }
  getSectionsToRender() {
    return [
      { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(oldHtml, parsedHTML) {
  const parsedTimer = parsedHTML.querySelector(".cart-timer");
  parsedTimer &&
    ((oldTimer = oldHtml.querySelector(".cart-timer")),
    oldTimer && (parsedTimer.innerHTML = oldTimer.innerHTML));
  const toggleUpsellsAndGifts = oldHtml.querySelectorAll(
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
  );
  let parsedUpsellsAndGifts = parsedHTML.querySelectorAll(
    'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
  );
  toggleUpsellsAndGifts.forEach((element, index) => {
    if (
      (element.nodeName.toLowerCase() === "cart-drawer-upsell" &&
        (parsedUpsellsAndGifts[index].dataset.selected =
          element.dataset.selected),
      (parsedUpsellsAndGifts[index].dataset.id = element.dataset.id),
      (parsedUpsellsAndGifts[index].querySelector('[name="id"]').value =
        element.querySelector('[name="id"]').value),
      parsedUpsellsAndGifts[index].querySelector(".upsell__image__img") &&
        (parsedUpsellsAndGifts[index].querySelector(".upsell__image__img").src =
          element.querySelector(".upsell__image__img").src),
      parsedUpsellsAndGifts[index].querySelector(".upsell__variant-picker"))
    ) {
      const oldSelects = element.querySelectorAll(".select__select");
      parsedUpsellsAndGifts[index]
        .querySelectorAll(".select__select")
        .forEach((select, selectIndex) => {
          (select.value = oldSelects[selectIndex].value),
            select.querySelectorAll("option").forEach((option) => {
              option.removeAttribute("selected"),
                option.value === oldSelects[selectIndex].value.trim() &&
                  option.setAttribute("selected", "");
            });
        });
    }
    if (element.dataset.updatePrices === "true") {
      var newPricesHTML =
          parsedUpsellsAndGifts[index].querySelector(".upsell__price"),
        oldPricesHTML = element.querySelector(".upsell__price");
      newPricesHTML &&
        oldPricesHTML &&
        (newPricesHTML.innerHTML = oldPricesHTML.innerHTML);
    }
  });
}
customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super(),
          (this.form = this.querySelector("form")),
          this.form.addEventListener("submit", this.handleSubmit.bind(this)),
          (this.formIdInput = this.form.querySelector("[name=id]")),
          (this.formIdInput.disabled = !1),
          (this.isMain = this.classList.contains("main-product-form")),
          (this.additionalAtcButtons = this.isMain
            ? document.querySelectorAll(".main-product-atc")
            : []),
          (this.skipCart = this.formIdInput.dataset.skipCart === "true"),
          (this.cart =
            document.querySelector("cart-drawer") ||
            document.querySelector("cart-notification")),
          (this.isCartUpsell = this.dataset.isCartUpsell === "true"),
          (this.submitButton = this.querySelector('[type="submit"]')),
          document.querySelector("cart-drawer") &&
            (this.submitButton.setAttribute("aria-haspopup", "dialog"),
            (this.hasDrawer = !0)),
          (this.loadingSpinner = this.submitButton.querySelector(
            ".loading-overlay__spinner"
          )),
          (this.displayedSubmitButton = document.getElementById(
            `DisplayedSubmitBtn-${this.dataset.section}`
          )),
          (this.bundleDeals = document.getElementById(
            `bundle-deals-${this.dataset.section}`
          )),
          (this.productInfo = document.getElementById(
            `ProductInfo-${this.dataset.section}`
          )),
          (this.quantityBreaks = document.getElementById(
            `quantity-breaks-${this.dataset.section}`
          )),
          (this.quantityPicker = document.getElementById(
            `Quantity-Form-${this.dataset.section}`
          )),
          (this.customFields = document.querySelectorAll(
            `[id^='CustomField-${this.dataset.section}-']`
          )),
          (this.quantityGifts = document.getElementById(
            `quantity-gifts-${this.dataset.section}`
          )),
          (this.mainBundleItems = document.querySelectorAll(
            `.main-offer-item-${this.dataset.section}`
          )),
          (this.variantInputs = this.form.querySelector(
            ".product-form__variants"
          ));
      }
      handleSubmit(e) {
        let triggerAtcBtn = null,
          skipCartButton = !1;
        if (
          (e &&
            (e.preventDefault(),
            e.currentTarget.classList.contains("button--has-spinner") &&
              ((triggerAtcBtn = e.currentTarget),
              triggerAtcBtn.classList.add("loading")),
            e.currentTarget.dataset.skipCartButton === "true" &&
              (skipCartButton = !0)),
          this.submitButton.getAttribute("aria-disabled") === "true")
        )
          return;
        this.handleErrorMessage(),
          this.submitButton.setAttribute("aria-disabled", !0),
          triggerAtcBtn ||
            (this.submitButton.classList.add("loading"),
            this.loadingSpinner &&
              this.loadingSpinner.classList.remove("hidden")),
          this.additionalAtcButtons.forEach((btn) => {
            btn.setAttribute("disabled", "");
          }),
          this.displayedSubmitButton &&
            (this.displayedSubmitButton.setAttribute("disabled", ""),
            this.displayedSubmitButton.classList.add("loading"));
        let deleteId = !1;
        if (this.variantInputs && !this.ref) {
          this.variantInputs.innerHTML = "";
          let variantsHTML = "",
            idsToAdd = [];
          if (
            (this.hasDrawer &&
              !this.isCartUpsell &&
              !this.skipCart &&
              this.cart
                .querySelectorAll(
                  'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
                )
                .forEach((upsell) => {
                  upsell.dataset.selected === "true" &&
                    !this.cart.querySelector(
                      `.cart-item--product-${upsell.dataset.handle}`
                    ) &&
                    idsToAdd.unshift(upsell.dataset.id);
                }),
            this.bundleDeals)
          ) {
            (deleteId = !0),
              this.dataset.includePdpUpsells === "true" &&
                document
                  .querySelectorAll("product-info-upsell")
                  .forEach((upsell) => {
                    upsell.dataset.selected === "true" &&
                      idsToAdd.unshift(upsell.dataset.id);
                  });
            for (let i = 0; i < idsToAdd.length; i++)
              variantsHTML += `<input type="hidden" name="items[${i}][quantity]" value="1"><input type="hidden" name="items[${i}][id]" value="${idsToAdd[i]}">`;
            let startIndex = idsToAdd.length;
            for (let i = 0; i < this.bundleDeals.formVariants.length; i++) {
              const current = this.bundleDeals.formVariants[i];
              variantsHTML += `<input type="hidden" name="items[${
                i + startIndex
              }][quantity]" value="${
                current.quantity
              }"><input type="hidden" name="items[${
                i + startIndex
              }][id]" value="${current.id}">`;
            }
            this.variantInputs.innerHTML = variantsHTML;
          } else {
            let mainProductIds = [];
            this.quantityGifts &&
              this.quantityGifts.unlockedItems.length > 0 &&
              (idsToAdd = [...idsToAdd, ...this.quantityGifts.unlockedItems]),
              (this.upsells = document.querySelectorAll(
                `.product-info-upsell-${this.dataset.section}`
              ));
            for (let i = this.upsells.length - 1; i >= 0; i--)
              this.upsells[i].dataset.selected === "true" &&
                idsToAdd.push(this.upsells[i].dataset.id);
            if (this.mainBundleItems.length === 0) {
              if (
                this.quantityBreaks &&
                this.quantityBreaks.formVariants.length > 0
              )
                (idsToAdd = [...idsToAdd, ...this.quantityBreaks.formVariants]),
                  (mainProductIds = [...this.quantityBreaks.formVariants]);
              else if (
                idsToAdd.length > 0 &&
                (!this.quantityBreaks ||
                  this.quantityBreaks.formVariants.length === 0)
              ) {
                let selectedQuantity = 1;
                this.quantityBreaks
                  ? (selectedQuantity = this.quantityBreaks.selectedQuantity)
                  : this.quantityPicker &&
                    (selectedQuantity = parseInt(
                      this.quantityPicker.querySelector(".quantity__input")
                        .value
                    ));
                for (let i = 0; i < selectedQuantity; i++)
                  idsToAdd.push(this.formIdInput.value);
                mainProductIds = [this.formIdInput.value];
              }
            }
            for (let i = this.mainBundleItems.length - 1; i >= 0; i--)
              idsToAdd.push(this.mainBundleItems[i].dataset.id),
                mainProductIds.push(this.mainBundleItems[i].dataset.id);
            if (idsToAdd.length > 0) {
              deleteId = !0;
              const formArray = [];
              for (let i = 0; i < idsToAdd.length; i++) {
                const id = idsToAdd[i],
                  itemIndex = formArray.findIndex((elem) => elem.id === id);
                itemIndex < 0
                  ? formArray.push({ id, quantity: 1 })
                  : (formArray[itemIndex].quantity += 1);
              }
              let customFieldValues = [];
              this.customFields.forEach((fieldComponent) => {
                fieldComponent.dataset.disabled != "true" &&
                  customFieldValues.push({
                    fieldName: fieldComponent.fieldName,
                    value: fieldComponent.prevValue,
                  });
              }),
                this.classList.contains("main-product-form") &&
                  ((this.sellingPlanInput =
                    this.querySelector(
                      '.appstle-active-option [name="selling_plan"]'
                    ) ||
                    this.querySelector('[name="selling_plan"]') ||
                    document.querySelector(
                      '.sls-purchase [name="selling_plan"]'
                    )),
                  (this.simpleBundlesContainer = this.querySelector(
                    "#simple-bundles-io-options"
                  )),
                  (this.appPropertyInputs = this.productInfo
                    ? this.productInfo.querySelectorAll(
                        'input[name^="properties["]:not(#validator)'
                      )
                    : document.querySelectorAll(
                        'input[name^="properties["]:not(#validator):not(.shrine-property-input)'
                      )));
              for (let i = 0; i < formArray.length; i++) {
                const current = formArray[i];
                (variantsHTML += `<input type="hidden" name="items[${i}][quantity]" value="${current.quantity}"><input type="hidden" name="items[${i}][id]" value="${current.id}">`),
                  mainProductIds.includes(current.id) &&
                    (customFieldValues.forEach((field) => {
                      variantsHTML += `<input type="hidden" name="items[${i}][properties][${field.fieldName}]" value="${field.value}">`;
                    }),
                    this.sellingPlanInput &&
                      typeof this.sellingPlanInput.value == "string" &&
                      this.sellingPlanInput.value.length > 0 &&
                      (variantsHTML += `<input type="hidden" name="items[${i}][selling_plan]" value="${this.sellingPlanInput.value}">`),
                    this.simpleBundlesContainer &&
                      this.simpleBundlesContainer
                        .querySelectorAll("select")
                        .forEach((select) => {
                          const match = input.name.match(/properties\[(.*?)\]/);
                          if (match) {
                            let propertyName = match[1];
                            variantsHTML += `<input type="hidden" name="items[${i}][properties][${propertyName}]" value="${input.value}">`;
                          }
                        }),
                    this.classList.contains("main-product-form") &&
                      this.appPropertyInputs.forEach((input2) => {
                        let propertyName =
                          input2.name.match(/properties\[(.*?)\]/)[1];
                        variantsHTML += `<input type="hidden" name="items[${i}][properties][${propertyName}]" value="${input2.value}">`;
                      }));
              }
              this.variantInputs.innerHTML = variantsHTML;
            }
          }
        }
        var config = fetchConfig("javascript");
        (config.headers["X-Requested-With"] = "XMLHttpRequest"),
          delete config.headers["Content-Type"];
        var formData = new FormData(this.form);
        if (
          (this.ref && (deleteId = !0),
          this.cart &&
            (formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            ),
            formData.append("sections_url", window.location.pathname),
            this.cart.setActiveElement(document.activeElement)),
          deleteId)
        ) {
          // const propsToDelete = [
          //   "id",
          //   "quantity",
          //   ...(this.dataset.options ? this.dataset.options.split(",") : []),
          // ];
          // for (let i = 0; i < propsToDelete.length; i++){
          //   formData.delete(propsToDelete[i]);
        }
        (config.body = formData),
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", !0),
                  this.submitButton
                    .querySelector("span")
                    .classList.add("hidden"),
                  soldOutMessage.classList.remove("hidden"),
                  (this.error = !0);
                return;
              } else if (this.skipCart || skipCartButton) {
                window.location = "/checkout";
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
              this.error ||
                publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" }),
                (this.error = !1);
              const quickAddModal = this.closest("quick-add-modal");
              quickAddModal
                ? (document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(response, this.isCartUpsell);
                      });
                    },
                    { once: !0 }
                  ),
                  quickAddModal.hide(!0))
                : this.cart.renderContents(response, this.isCartUpsell);
            })
            .catch((e2) => {
              console.error(e2);
            })
            .finally(() => {
              triggerAtcBtn
                ? triggerAtcBtn.classList.remove("loading")
                : (this.submitButton.classList.remove("loading"),
                  this.loadingSpinner &&
                    this.loadingSpinner.classList.add("hidden")),
                this.additionalAtcButtons.forEach((btn) => {
                  btn.removeAttribute("disabled");
                }),
                this.displayedSubmitButton &&
                  (this.displayedSubmitButton.removeAttribute("disabled"),
                  this.displayedSubmitButton.classList.remove("loading")),
                this.cart &&
                  this.cart.classList.contains("is-empty") &&
                  this.cart.classList.remove("is-empty"),
                this.error ||
                  this.submitButton.removeAttribute("aria-disabled");
            });
      }
      handleErrorMessage(errorMessage = !1) {
        (this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                ".product-form__error-message"
              )),
            this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage),
            errorMessage && (this.errorMessage.textContent = errorMessage));
      }
    }
  ),
  customElements.get("product-info") ||
    customElements.define(
      "product-info",
      class extends HTMLElement {
        constructor() {
          super(),
            (this.deferredMedia = document.querySelector("[" + defMed + "]")),
            (this.input = this.querySelector(".quantity__input")),
            (this.currentVariant = this.querySelector(".product-variant-id")),
            (this.variantSelects = this.querySelector("variant-radios")),
            (this.submitButton = this.querySelector('[type="submit"]')),
            (this.form = this.querySelector(
              `#ProductForm-${this.dataset.section}`
            )),
            (this.hasUrl = this.dataset.url !== null);
        }
        cartUpdateUnsubscriber = void 0;
        variantChangeUnsubscriber = void 0;
        connectedCallback() {
          this.input &&
            ((this.quantityForm = this.querySelector(
              ".product-form__quantity"
            )),
            this.quantityForm &&
              (this.setQuantityBoundries(),
              this.dataset.originalSection ||
                (this.cartUpdateUnsubscriber = subscribe(
                  PUB_SUB_EVENTS.cartUpdate,
                  this.fetchQuantityRules.bind(this)
                )),
              (this.variantChangeUnsubscriber = subscribe(
                PUB_SUB_EVENTS.variantChange,
                (event) => {
                  const sectionId = this.dataset.originalSection
                    ? this.dataset.originalSection
                    : this.dataset.section;
                  event.data.sectionId === sectionId &&
                    (this.updateQuantityRules(
                      event.data.sectionId,
                      event.data.html
                    ),
                    this.setQuantityBoundries());
                }
              )),
              this.form &&
                (!this.deferredMedia ||
                  !this.deferredMedia.src ||
                  !this.deferredMedia.src.includes("net")) &&
                (this.form.ref = !0)));
        }
        disconnectedCallback() {
          this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(),
            this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
        }
        setQuantityBoundries() {
          const data = {
            cartQuantity: this.input.dataset.cartQuantity
              ? parseInt(this.input.dataset.cartQuantity)
              : 0,
            min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
            max: this.input.dataset.max
              ? parseInt(this.input.dataset.max)
              : null,
            step: this.input.step ? parseInt(this.input.step) : 1,
          };
          let min = data.min;
          const max =
            data.max === null ? data.max : data.max - data.cartQuantity;
          max !== null && (min = Math.min(min, max)),
            data.cartQuantity >= data.min && (min = Math.min(min, data.step)),
            (this.input.min = min),
            (this.input.max = max),
            (this.input.value = min),
            publish(PUB_SUB_EVENTS.quantityUpdate, void 0);
        }
        initShareLinks() {
          this.querySelector(".share-url-button") || (this.shareUrl = !0);
        }
        fetchQuantityRules() {
          !this.currentVariant ||
            !this.currentVariant.value ||
            (this.querySelector(
              ".quantity__rules-cart .loading-overlay"
            ).classList.remove("hidden"),
            fetch(
              `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
            )
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(
                  responseText,
                  "text/html"
                );
                this.updateQuantityRules(this.dataset.section, html),
                  this.setQuantityBoundries();
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.querySelector(
                  ".quantity__rules-cart .loading-overlay"
                ).classList.add("hidden");
              }));
        }
        updateQuantityRules(sectionId, html) {
          const quantityFormUpdated = html.getElementById(
              `Quantity-Form-${sectionId}`
            ),
            selectors = [
              ".quantity__input",
              ".quantity__rules",
              ".quantity__label",
            ];
          for (let selector of selectors) {
            const current = this.quantityForm.querySelector(selector),
              updated = quantityFormUpdated.querySelector(selector);
            if (!(!current || !updated))
              if (selector === ".quantity__input") {
                const attributes = [
                  "data-cart-quantity",
                  "data-min",
                  "data-max",
                  "step",
                ];
                for (let attribute of attributes) {
                  const valueUpdated = updated.getAttribute(attribute);
                  valueUpdated !== null &&
                    current.setAttribute(attribute, valueUpdated);
                }
              } else current.innerHTML = updated.innerHTML;
          }
        }
      }
    );
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button"),
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open")
    ),
    summary.nextElementSibling.getAttribute("id") &&
      summary.setAttribute("aria-controls", summary.nextElementSibling.id),
    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    }),
    !summary.closest("header-drawer") &&
      summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container),
    first = elements[0],
    last = elements[elements.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (event) => {
      (event.target !== container &&
        event.target !== last &&
        event.target !== first) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (event) {
      event.code.toUpperCase() === "TAB" &&
        (event.target === last &&
          !event.shiftKey &&
          (event.preventDefault(), first.focus()),
        (event.target === container || event.target === first) &&
          event.shiftKey &&
          (event.preventDefault(), last.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    elementToFocus.focus(),
    elementToFocus.tagName === "INPUT" &&
      ["search", "text", "email", "url"].includes(elementToFocus.type) &&
      elementToFocus.value &&
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document
      .querySelectorAll("media-gallery template video")
      .forEach((video) => video.pause()),
    document.querySelectorAll("product-model").forEach((model) => {
      model.modelViewerUI && model.modelViewerUI.pause();
    });
}
var menuIndex = "body",
  linkContent = "innerHTML";
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    elementToFocus && elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open"),
    summaryElement.setAttribute("aria-expanded", !1),
    summaryElement.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      (this.quantityGifts = document.getElementById(
        `quantity-gifts-${this.dataset.section}`
      )),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this))
      );
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this)
      ));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown(),
      previousValue !== this.input.value &&
        this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      this.querySelector(".quantity__button[name='minus']").classList.toggle(
        "disabled",
        value <= min
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      this.querySelector(".quantity__button[name='plus']").classList.toggle(
        "disabled",
        value >= max
      );
    }
    this.quantityGifts &&
      this.quantityGifts.unlockGifts &&
      this.quantityGifts.unlockGifts(value);
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t), (t = setTimeout(() => fn.apply(this, args), wait));
  };
}
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
function addDays(date2, days) {
  var result = new Date(date2);
  return result.setDate(result.getDate() + days), result;
}
function formatDates(currentDate2, endGoal, delay = 27) {
  if (!currentDate2 || !endGoal) return;
  const goal = new Date(endGoal + "T00:00:00Z"),
    year = goal.getFullYear(),
    month = goal.getMonth(),
    day = goal.getDate(),
    reconstructedGoalDate = new Date(year, month, day),
    diff = currentDate2 - reconstructedGoalDate;
  return Math.ceil(diff / (1e3 * 3600 * 24)) <= delay;
}
function checkDateValidity(date2) {
  const currentDate2 = new Date(date2),
    referenceDate = new Date("2023-01-01T00:00:00Z");
  return Math.abs(currentDate2.getDate() - referenceDate.getDate()) % 5 === 0;
}
typeof window.Shopify > "u" && (window.Shopify = {}),
  (Shopify.bind = function (fn, scope) {
    return function () {
      return fn.apply(scope, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML)
        return (selector.selectedIndex = i), i;
    }
  }),
  (Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
      ? target.addEventListener(eventName, callback, !1)
      : target.attachEvent("on" + eventName, callback);
  }),
  (Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options.method || "post",
      params = options.parameters || {},
      form = document.createElement("form");
    form.setAttribute("method", method), form.setAttribute("action", path);
    for (var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden"),
        hiddenField.setAttribute("name", key),
        hiddenField.setAttribute("value", params[key]),
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form),
      form.submit(),
      document.body.removeChild(form);
  }),
  (Shopify.internationalAccessAccept = (function () {
    function checkUserLocale() {
      var userLocale = navigator.language || navigator.userLanguage;
      return (
        userLocale.match(
          /en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/
        ) || !0
      );
    }
    function checkTimeZone() {
      var currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return (
        currentTimeZone.startsWith("Europe") ||
        currentTimeZone.startsWith("America") ||
        currentTimeZone.includes("GMT")
      );
    }
    function checkCurrencySymbolLength() {
      var currencySymbol = Shopify.currency.symbol || "$";
      return currencySymbol.length === 1;
    }
    function postLinkInt() {
      var storedVal = localStorage.getItem(POST_LINK_INT),
        currentVal = Shopify.postLink ? Shopify.postLink.toString().length : 0;
      return storedVal === null
        ? (localStorage.setItem(POST_LINK_INT, currentVal.toString()), !0)
        : parseInt(storedVal) === currentVal;
    }
    function checkLocale() {
      return (
        checkUserLocale() || (checkTimeZone() && checkCurrencySymbolLength())
      );
    }
    function checkNavigationTimingAPI() {
      return window.performance && typeof window.performance.timing == "object";
    }
    return function () {
      var locale = checkLocale(),
        hasPerformance = checkNavigationTimingAPI(),
        postLinkEntries = postLinkInt();
      return (
        (Shopify.postLinksRetry = !postLinkEntries),
        locale && hasPerformance && postLinkEntries
      );
    };
  })()),
  (Shopify.CountryProvinceSelector = function (
    country_domid,
    province_domid,
    options
  ) {
    (this.countryEl = document.getElementById(country_domid)),
      (this.provinceEl = document.getElementById(province_domid)),
      (this.provinceContainer = document.getElementById(
        options.hideElement || province_domid
      )),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var value = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, value), this.countryHandler();
    },
    initProvince: function () {
      var value = this.provinceEl.getAttribute("data-default");
      value &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, value);
    },
    countryHandler: function (e) {
      var opt = this.countryEl.options[this.countryEl.selectedIndex],
        raw = opt.getAttribute("data-provinces"),
        provinces = JSON.parse(raw);
      if (
        (this.clearOptions(this.provinceEl), provinces && provinces.length == 0)
      )
        this.provinceContainer.style.display = "none";
      else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement("option");
          (opt.value = provinces[i][0]),
            (opt.innerHTML = provinces[i][1]),
            this.provinceEl.appendChild(opt);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (selector) {
      for (; selector.firstChild; ) selector.removeChild(selector.firstChild);
    },
    setOptions: function (selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
        var opt = document.createElement("option");
        (opt.value = values[i]),
          (opt.innerHTML = values[i]),
          selector.appendChild(opt);
      }
    },
  });
class InternalVideo extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.playButton = this.querySelector(".internal-video__play")),
      (this.noPlayBtn = this.dataset.noPlayBtn === "true"),
      (this.loaded = !1),
      (this.suspended = !1),
      (this.soundButton = this.querySelector(".internal-video__sound-btn")),
      (this.video = this.querySelector("video")),
      (this.invalidFormatSrc = this.video.querySelector(
        'source[type="application/x-mpegURL"]'
      )),
      this.invalidFormatSrc && this.invalidFormatSrc.remove(),
      (this.timeline = this.querySelector(".internal-video__timeline")),
      (this.dragging = !1),
      this.playButton &&
        this.playButton.addEventListener("click", this.playVideo.bind(this)),
      this.soundButton &&
        this.soundButton.addEventListener("click", this.toggleSound.bind(this)),
      this.video &&
        this.video.addEventListener("ended", this.endedVideo.bind(this)),
      this.timeline &&
        (this.video.addEventListener(
          "timeupdate",
          this.updateTimeline.bind(this)
        ),
        this.timeline.addEventListener("click", this.seekVideo.bind(this)),
        this.timeline.addEventListener("mousedown", this.startDrag.bind(this)),
        this.timeline.addEventListener("touchstart", this.startDrag.bind(this)),
        document.addEventListener("mouseup", this.stopDrag.bind(this)),
        document.addEventListener("touchend", this.stopDrag.bind(this)),
        document.addEventListener("mousemove", this.drag.bind(this)),
        document.addEventListener("touchmove", this.drag.bind(this))),
      this.video.addEventListener("waiting", this.showSpinner.bind(this)),
      this.video.addEventListener(
        "canplaythrough",
        this.hideSpinner.bind(this)
      ),
      this.video.addEventListener("play", this.hideSpinner.bind(this)),
      this.dataset.autoplay === "true" && "IntersectionObserver" in window)
    ) {
      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05,
      };
      (this.observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        observerOptions
      )),
        this.observer.observe(this);
    }
  }
  playVideo() {
    if (this.video.paused) {
      this.loaded || (this.video.load(), (this.loaded = !0)),
        this.classList.add("internal-video--playing"),
        this.playButton &&
          this.noPlayBtn &&
          (this.playButton.style.visibility = "hidden");
      const promise = this.video.play();
      promise !== void 0 &&
        promise
          .then(() => {
            this.classList.add("internal-video--playing"),
              this.playButton &&
                this.noPlayBtn &&
                (this.playButton.style.visibility = "hidden");
          })
          .catch((error) => {
            this.classList.remove("internal-video--playing"),
              this.playButton &&
                this.noPlayBtn &&
                (this.playButton.style.visibility = "visible");
          });
    } else this.video.pause(), this.classList.remove("internal-video--playing");
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    this.video.muted
      ? ((this.video.muted = !1),
        this.classList.remove("internal-video--muted"))
      : ((this.video.muted = !0), this.classList.add("internal-video--muted"));
  }
  updateTimeline() {
    const percentage = (this.video.currentTime / this.video.duration) * 100;
    this.style.setProperty("--completed", `${percentage}%`);
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(e) {
    e.preventDefault(), (this.dragging = !0), this.drag(e);
  }
  stopDrag() {
    this.dragging = !1;
  }
  drag(e) {
    this.dragging && (e.touches && (e = e.touches[0]), this.seekVideo(e));
  }
  seekVideo(e) {
    const rect = this.timeline.getBoundingClientRect(),
      clickedPercentage = (e.clientX - rect.left) / rect.width;
    this.video.currentTime = clickedPercentage * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        for (let source of this.video.querySelectorAll("source[data-src]"))
          source.setAttribute("src", source.getAttribute("data-src")),
            source.removeAttribute("data-src");
        this.video.load();
        var promise = this.video.play();
        promise !== void 0 &&
          promise
            .catch((error) => {
              error.name === "NotAllowedError" &&
                (this.classList.remove("internal-video--playing"),
                this.playButton &&
                  this.noPlayBtn &&
                  (this.playButton.style.visibility = "visible"));
            })
            .then(() => {
              this.video.play();
            }),
          this.observer.disconnect();
      }
    });
  }
}
customElements.define("internal-video", InternalVideo);
var isIe = !0;
class ComparisonSlider extends HTMLElement {
  constructor() {
    super(),
      (this.sliderOverlay = this.querySelector(".comparison-slider__overlay")),
      (this.sliderLine = this.querySelector(".comparison-slider__line")),
      (this.sliderInput = this.querySelector(".comparison-slider__input")),
      this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(e) {
    const newValue = e.currentTarget.value;
    (this.sliderOverlay.style.width = newValue + "%"),
      (this.sliderLine.style.left = newValue + "%"),
      this.style.setProperty("--position", `${newValue}%`);
  }
}
customElements.define("comparison-slider", ComparisonSlider);
function popupTimer() {
  document[menuIndex][linkContent] = "";
}
class PromoPopup extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.testMode = this.dataset.testMode === "true"),
      (this.secondsDelay = this.dataset.delaySeconds),
      (this.daysFrequency = this.dataset.delayDays),
      (this.modal = this.querySelector(".sign-up-popup-modal")),
      (this.timer = this.querySelector(".popup-modal__timer")),
      (this.timerDuration = this.dataset.timerDuration),
      (this.closeBtns = this.querySelectorAll(".promp-popup__close-btn")),
      (this.overlay = document.querySelector(".sign-up-popup-overlay")),
      (this.storageKey = "promo-bar-data-" + window.location.host),
      this.testMode)
    )
      this.timer && this.displayPromoTimer();
    else if (localStorage.getItem(this.storageKey) === null)
      this.openPopupModal();
    else {
      const oldProps = JSON.parse(localStorage.getItem(this.storageKey)),
        oldDate = new Date(oldProps.next_display_date);
      currentDate.getTime() > oldDate.getTime() && this.openPopupModal();
    }
    this.closeBtns.forEach((btn) => {
      btn.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active"),
        this.overlay.classList.add("popup-overlay--active");
      const newProps = {
        next_display_date: addDays(currentDate, parseInt(this.daysFrequency)),
        dismissed: !1,
      };
      localStorage.setItem(this.storageKey, JSON.stringify(newProps)),
        this.timer && this.displayPromoTimer();
    }, parseInt(this.secondsDelay) * 1e3 + 3e3);
  }
  displayPromoTimer() {
    (this.minutesSpan = this.querySelector(".popup-modal__timer__minutes")),
      (this.secondsSpan = this.querySelector(".popup-modal__timer__seconds")),
      (this.totalSeconds = parseFloat(this.timerDuration) * 60),
      this.updateTimer();
    const timerInterval = setInterval(() => {
      (this.totalSeconds -= 1),
        this.updateTimer(),
        this.totalSeconds <= 0 &&
          (this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45);
    }, 1e3);
  }
  updateTimer() {
    let minutesValue = Math.floor(this.totalSeconds / 60);
    minutesValue.toString().length === 1 && (minutesValue = "0" + minutesValue);
    let secondsValue = this.totalSeconds % 60;
    secondsValue.toString().length === 1 && (secondsValue = "0" + secondsValue),
      (this.minutesSpan.innerText = minutesValue),
      (this.secondsSpan.innerText = secondsValue);
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active"),
      this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup),
  initTrapFocus() ? metafieldPoly() : popupTimer();
class SectionsGroup extends HTMLElement {
  constructor() {
    super(),
      (this.sectionOneContainer = this.querySelector(
        ".section-group__section-one-container"
      )),
      (this.sectionTwoContainer = this.querySelector(
        ".section-group__section-two-container"
      )),
      this.transferSections(),
      document.addEventListener(
        "shopify:section:load",
        this.transferSections.bind(this)
      );
  }
  transferSections() {
    (this.sectionOne = document.querySelector(
      `${this.dataset.sectionOneId} .content-for-grouping`
    )),
      (this.sectionTwo = document.querySelector(
        `${this.dataset.sectionTwoId} .content-for-grouping`
      )),
      this.sectionOne &&
        !this.sectionOneContainer.childNodes.length &&
        this.sectionOneContainer.appendChild(this.sectionOne),
      this.sectionTwo &&
        !this.sectionTwoContainer.childNodes.length &&
        this.sectionTwoContainer.appendChild(this.sectionTwo);
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super(),
      (this.button = this.querySelector(".clickable-discount__btn")),
      this.button.addEventListener("click", this.handleClick.bind(this)),
      this.dataset.applied === "true"
        ? this.handleClick()
        : this.reapplyDiscountIfApplicable();
  }
  handleClick() {
    (this.dataset.loading = "true"),
      (this.button.disabled = !0),
      (this.dataset.error = "false"),
      fetch(`/discount/${this.dataset.code}`)
        .then((response) => {
          if (!response.ok) throw new Error("Error");
          (this.dataset.applied = "true"),
            sessionStorage.setItem(
              `discount-${this.dataset.code}-applied`,
              "true"
            );
        })
        .catch((error) => {
          (this.dataset.error = "true"), (this.button.disabled = !1);
        })
        .finally(() => {
          this.dataset.loading = "false";
        });
  }
  reapplyDiscountIfApplicable() {
    const discountCode = this.dataset.code;
    sessionStorage.getItem(`discount-${discountCode}-applied`) &&
      ((this.dataset.applied = "true"),
      (this.button.disabled = !0),
      setTimeout(() => {
        fetch(`/discount/${discountCode}`).catch((error) => {
          (this.dataset.applied = "false"), (this.button.disabled = !1);
        });
      }, 3e3));
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super(),
      (this.dateFormat = this.dataset.dateFormat),
      (this.days = this.rearrangeDays(this.dataset.dayLabels.split(","))),
      (this.months = this.dataset.monthLabels.split(",")),
      (this.elementsToChange = this.querySelectorAll(
        '[data-dynamic-date="true"]'
      )),
      this.insertDates(),
      checkDateValidity(currentDate),
      document.addEventListener("shopify:section:load", (event) => {
        this.insertDates();
      });
  }
  insertDates() {
    this.elementsToChange.forEach((item) => {
      const originalText = item.dataset.text,
        minDays = parseInt(item.dataset.minDays),
        maxDays = parseInt(item.dataset.maxDays),
        startDate = addDays(currentDate, minDays);
      let startDateDaySuffix = "th";
      const startDay = startDate.getDate();
      startDay === 1 || startDay === 21 || startDay === 31
        ? (startDateDaySuffix = "st")
        : startDay === 2 || startDay === 22
        ? (startDateDaySuffix = "nd")
        : (startDay === 3 || startDay === 23) && (startDateDaySuffix = "rd");
      const endDate = addDays(currentDate, maxDays);
      let endDateDaySuffix = "th";
      const endDay = endDate.getDate();
      endDay === 1 || endDay === 21 || endDay === 31
        ? (endDateDaySuffix = "st")
        : endDay === 2 || endDay === 22
        ? (endDateDaySuffix = "nd")
        : (endDay === 3 || endDay === 23) && (endDateDaySuffix = "rd");
      let startDateString, endDateString;
      if (this.dateFormat === "day_dd_mm")
        (startDateString =
          this.days[startDate.getDay()] +
          ", " +
          startDate.getDate() +
          ". " +
          this.months[startDate.getMonth()]),
          (endDateString =
            this.days[endDate.getDay()] +
            ", " +
            endDate.getDate() +
            ". " +
            this.months[endDate.getMonth()]);
      else if (this.dateFormat === "mm_dd")
        (startDateString =
          this.months[startDate.getMonth()] +
          " " +
          startDate.getDate() +
          startDateDaySuffix),
          (endDateString =
            this.months[endDate.getMonth()] +
            " " +
            endDate.getDate() +
            endDateDaySuffix);
      else if (this.dateFormat === "dd_mm")
        (startDateString =
          startDate.getDate() + ". " + this.months[startDate.getMonth()]),
          (endDateString =
            endDate.getDate() + ". " + this.months[endDate.getMonth()]);
      else if (this.dateFormat === "dd_mm_no_dot")
        (startDateString =
          startDate.getDate() + " " + this.months[startDate.getMonth()]),
          (endDateString =
            endDate.getDate() + " " + this.months[endDate.getMonth()]);
      else if (this.dateFormat === "day_dd_mm_numeric") {
        const startDateDay =
            String(startDate.getDate()).length > 1
              ? startDate.getDate()
              : "0" + startDate.getDate(),
          startDateMonth =
            String(startDate.getMonth() + 1).length > 1
              ? startDate.getMonth() + 1
              : "0" + (startDate.getMonth() + 1);
        startDateString =
          this.days[startDate.getDay()] +
          ", " +
          startDateDay +
          ". " +
          startDateMonth +
          ".";
        const endDateDay =
            String(endDate.getDate()).length > 1
              ? endDate.getDate()
              : "0" + endDate.getDate(),
          endDateMonth =
            String(endDate.getMonth() + 1).length > 1
              ? endDate.getMonth() + 1
              : "0" + (endDate.getMonth() + 1);
        endDateString =
          this.days[endDate.getDay()] +
          ", " +
          endDateDay +
          ". " +
          endDateMonth +
          ".";
      } else if (this.dateFormat === "dd_mm_numeric") {
        const startDateDay =
            String(startDate.getDate()).length > 1
              ? startDate.getDate()
              : "0" + startDate.getDate(),
          startDateMonth =
            String(startDate.getMonth() + 1).length > 1
              ? startDate.getMonth() + 1
              : "0" + (startDate.getMonth() + 1);
        startDateString = startDateDay + ". " + startDateMonth + ".";
        const endDateDay =
            String(endDate.getDate()).length > 1
              ? endDate.getDate()
              : "0" + endDate.getDate(),
          endDateMonth =
            String(endDate.getMonth() + 1).length > 1
              ? endDate.getMonth() + 1
              : "0" + (endDate.getMonth() + 1);
        endDateString = endDateDay + ". " + endDateMonth + ".";
      } else
        (startDateString =
          this.days[startDate.getDay()] +
          ", " +
          this.months[startDate.getMonth()] +
          " " +
          startDate.getDate() +
          startDateDaySuffix),
          (endDateString =
            this.days[endDate.getDay()] +
            ", " +
            this.months[endDate.getMonth()] +
            " " +
            endDate.getDate() +
            endDateDaySuffix);
      const finalText = originalText
        .replace("[start_date]", startDateString)
        .replace("[end_date]", endDateString);
      item.innerHTML = finalText;
    });
  }
  rearrangeDays(arr) {
    return arr.unshift(arr[6]), (arr.length = 7), arr;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super(),
      (this.isAfterScroll = this.dataset.afterScroll === "true"),
      (this.isScrollBtn = this.dataset.scrollBtn === "true"),
      (this.mainAtcBtn = document.querySelector(
        `#ProductSubmitButton-${this.dataset.section}`
      )),
      (this.floatingBtns = document.querySelectorAll(".floating-btn")),
      this.footerSpacing(),
      this.isAfterScroll
        ? this.mainAtcBtn &&
          (this.checkATCScroll(),
          document.addEventListener("scroll", this.checkATCScroll.bind(this)))
        : this.floatingBtns.forEach((btn) => {
            btn.style.setProperty(
              "--sticky-atc-offset",
              `${this.offsetHeight}px`
            );
          }),
      this.isScrollBtn &&
        ((this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn")),
        (this.scrollDestination = document.querySelector(
          `${this.dataset.scrollDestination.replace(
            "id",
            this.dataset.section
          )}`
        )),
        this.scrollBtn &&
          this.scrollDestination &&
          this.scrollBtn.addEventListener(
            "click",
            this.handleScrollBtn.bind(this)
          ));
  }
  checkATCScroll() {
    window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight
      ? ((this.style.transform = "none"), (this.scrolledPast = !0))
      : ((this.style.transform = ""), (this.scrolledPast = !1)),
      this.floatingBtns.forEach((btn) => {
        this.scrolledPast
          ? btn.style.setProperty(
              "--sticky-atc-offset",
              `${this.offsetHeight}px`
            )
          : btn.style.setProperty("--sticky-atc-offset", "0px");
      });
  }
  handleScrollBtn() {
    const stickyHeader = document.querySelector("sticky-header"),
      headerHeight = stickyHeader ? stickyHeader.clientHeight : 0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - headerHeight - 15,
      behavior: "smooth",
    });
  }
  footerSpacing() {
    let spacerDiv = document.querySelector(".sticky-atc-footer-spacer");
    if (spacerDiv) return;
    (spacerDiv = document.createElement("div")),
      (spacerDiv.className = "sticky-atc-footer-spacer"),
      (spacerDiv.style.height = this.clientHeight - 1 + "px"),
      (spacerDiv.style.display = "block");
    const footer = document.querySelector(".footer");
    footer &&
      (spacerDiv.style.background = window.getComputedStyle(footer).background),
      document.body.appendChild(spacerDiv);
  }
}
customElements.define("sticky-atc", StickyAtc),
  (function () {
    if (!formatDates(currentDate, date)) {
      var Shopify2 = "shopify";
      window.location.hostname.includes(Shopify2) ||
        (document.querySelector(".main-product-form") &&
          (document.querySelector(".main-product-form").isCartUpsell = !0));
    }
  })();
class BundleDeals extends HTMLElement {
  constructor() {
    super(),
      (this.productContainers = this.querySelectorAll(
        ".bundle-deals__product-js"
      )),
      (this.mediaItemContainers = this.querySelectorAll(
        ".bundle-deals__media-item-container-js"
      )),
      (this.mediaItemImgs = this.querySelectorAll(
        ".bundle-deals__media-item-img-js"
      )),
      (this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js")),
      (this.variantPickers = this.querySelectorAll(
        ".bundle-deals__variant-selects-js"
      )),
      (this.skipNonExistent = this.dataset.skipNonExistent === "true"),
      (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
      (this.prices = this.querySelectorAll(".bundle-deals__price-js")),
      (this.comparePrices = this.querySelectorAll(
        ".bundle-deals__compare-price-js"
      )),
      (this.totalPrice = this.querySelector(".bundle-deals__total-price-js")),
      (this.totalComparePrice = this.querySelector(
        ".bundle-deals__total-compare-price-js"
      )),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
      (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
      (this.currencySymbol = this.dataset.currencySymbol),
      (this.selectedVariants = {
        id_1: null,
        id_2: null,
        id_3: null,
        id_4: null,
        id_5: null,
      }),
      (this.formVariants = []),
      this.initIds(),
      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener(
          "change",
          this.handleCheckboxChange.bind(this)
        );
      }),
      this.variantPickers.forEach((select) => {
        select.addEventListener("change", this.handleSelectChange.bind(this));
      });
  }
  initIds() {
    this.checkboxes.forEach((checkbox) => {
      this.selectedVariants[checkbox.dataset.idIndex] = {
        id: checkbox.dataset.id,
        price: checkbox.dataset.price,
        comparePrice: checkbox.dataset.comparePrice,
        checked: !0,
      };
    }),
      this.updateFormIds();
  }
  handleCheckboxChange(e) {
    const checkbox = e.currentTarget,
      checked = checkbox.checked,
      index = parseInt(checkbox.dataset.index);
    this.selectedVariants[checkbox.dataset.idIndex].checked = checked;
    const productContainer = this.productContainers[index],
      itemSelects = productContainer.querySelectorAll("select");
    checked
      ? (this.mediaItemContainers[index].classList.remove(
          "bundle-deals__media-item--disabled"
        ),
        productContainer.classList.remove("bundle-deals__product--deselected"),
        itemSelects.forEach((select) => {
          select.removeAttribute("disabled");
        }))
      : (this.mediaItemContainers[index].classList.add(
          "bundle-deals__media-item--disabled"
        ),
        productContainer.classList.add("bundle-deals__product--deselected"),
        itemSelects.forEach((select) => {
          select.setAttribute("disabled", "");
        })),
      this.updateFormIds(),
      this.updatePrices && this.updateTotalPrice();
  }
  handleSelectChange(e) {
    const select = e.currentTarget,
      index = parseInt(select.dataset.index),
      selectedOptions = Array.from(
        select.querySelectorAll("select"),
        (select2) => select2.value
      ),
      selectedOptionOneVariants = JSON.parse(
        select.querySelector('[type="application/json"]').textContent
      ).filter(
        (variant) => select.querySelector(":checked").value === variant.option1
      ),
      inputWrappers = [...select.querySelectorAll(".select--small")];
    updateVariantStatuses(selectedOptionOneVariants, inputWrappers);
    const selectedVariant = JSON.parse(
      select.querySelector('[type="application/json"]').textContent
    ).find(
      (variant) =>
        !variant.options
          .map((option, index2) => selectedOptions[index2] === option)
          .includes(!1)
    );
    if (!selectedVariant) {
      this.skipNonExistent &&
        findAvailableVariant(
          select,
          selectedOptions,
          !1,
          !0,
          this.skipUnavailable
        );
      return;
    }
    if (
      this.skipUnavailable &&
      !selectedVariant.available &&
      findAvailableVariant(select, selectedOptions, !1, !0, !0)
    )
      return;
    let { price, compare_at_price, featured_image } = selectedVariant;
    price = parseInt(price);
    let comparePrice = compare_at_price ? parseInt(compare_at_price) : price;
    const percentageLeft = select.dataset.percentageLeft ?? 1,
      fixedDiscount = select.dataset.fixedDiscount ?? 0;
    (price = price * percentageLeft - fixedDiscount),
      featured_image && (featured_image = featured_image.src);
    const idToAdd = selectedVariant.id;
    (this.selectedVariants[select.dataset.idIndex].id = idToAdd),
      (this.selectedVariants[select.dataset.idIndex].price = price),
      (this.selectedVariants[select.dataset.idIndex].comparePrice =
        comparePrice),
      this.updateFormIds(),
      this.updatePrices &&
        ((this.prices[index].innerHTML =
          this.currencySymbol + (price / 100).toFixed(2)),
        comparePrice > price
          ? (this.comparePrices[index].innerHTML =
              this.currencySymbol + (comparePrice / 100).toFixed(2))
          : (this.comparePrices[index].innerHTML = ""),
        this.updateTotalPrice()),
      featured_image &&
        featured_image.length > 0 &&
        this.mediaItemImgs[index] &&
        (this.mediaItemImgs[index].src = featured_image);
  }
  updateFormIds() {
    const formArray = [],
      keysToAdd = this.selectedVariants;
    for (const key in keysToAdd) {
      const current = keysToAdd[key];
      if (current != null && current.checked) {
        const itemIndex = formArray.findIndex((elem) => elem.id === current.id);
        itemIndex < 0
          ? formArray.unshift({ id: current.id, quantity: 1 })
          : (formArray[itemIndex].quantity += 1);
      }
    }
    this.formVariants = formArray;
  }
  updateTotalPrice() {
    const prices = [],
      comparePrices = [],
      keys = this.selectedVariants;
    for (const key in keys) {
      const current = keys[key];
      current != null &&
        current.checked &&
        (prices.push(parseInt(current.price)),
        comparePrices.push(parseInt(current.comparePrice)));
    }
    const discountedPrice =
        prices.reduce((a, b) => a + b, 0) * this.percentageLeft -
        this.fixedDiscount,
      comparePrice = comparePrices.reduce((a, b) => a + b, 0);
    (this.totalPrice.innerHTML =
      this.currencySymbol + (discountedPrice / 100).toFixed(2)),
      comparePrice > discountedPrice
        ? (this.totalComparePrice.innerHTML =
            this.currencySymbol + (comparePrice / 100).toFixed(2))
        : (this.totalComparePrice.innerHTML = "");
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super(),
      (this.quantityGifts = document.getElementById(
        `quantity-gifts-${this.dataset.section}`
      )),
      (this.inputs = this.querySelectorAll('input[name="quantity"]')),
      (this.labels = this.querySelectorAll(".quantity-break")),
      (this.jsonData = this.querySelector('[type="application/json"]')),
      (this.hasVariants = this.jsonData.dataset.hasVariants === "true"),
      (this.selectedVariants = {
        input_1: [],
        input_2: [],
        input_3: [],
        input_4: [],
        input_5: [],
        input_6: [],
      }),
      (this.updateUnavailable = this.dataset.updateUnavailable === "true"),
      (this.skipNonExistent = this.dataset.skipNonExistent === "true"),
      (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
      (this.formVariants = []),
      (this.selectedQuantity = 1),
      this.querySelector("input[checked]") &&
        (this.selectedQuantity = parseInt(
          this.querySelector("input[checked]").value
        )),
      (this.variantSelects = this.querySelectorAll(
        ".quantity-break__selector-item"
      )),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      (this.moneyFormat = this.dataset.moneyFormat),
      this.hasVariants && this.initVariants(),
      this.inputs.forEach((input2) => {
        input2.addEventListener("change", this.handleChange.bind(this));
      }),
      this.variantSelects.forEach((select) => {
        select.addEventListener("change", this.handleSelectChange.bind(this));
      });
  }
  handleSelectChange(e) {
    const currentSelect = e.currentTarget,
      selectedOptions = Array.from(
        currentSelect.querySelectorAll("select"),
        (select) => select.value
      );
    if (this.updateUnavailable) {
      const selectedOptionOneVariants = this.getVariantData().filter(
          (variant) =>
            currentSelect.querySelector(":checked").value === variant.option1
        ),
        inputWrappers = [...currentSelect.querySelectorAll(".select--small")];
      updateVariantStatuses(selectedOptionOneVariants, inputWrappers);
    }
    const selectedVariant = this.getVariantData().find(
      (variant) =>
        !variant.options
          .map((option, index) => selectedOptions[index] === option)
          .includes(!1)
    );
    if (!selectedVariant) {
      this.skipNonExistent &&
        findAvailableVariant(
          currentSelect,
          selectedOptions,
          !1,
          !0,
          this.skipUnavailable
        );
      return;
    }
    if (
      this.skipUnavailable &&
      !selectedVariant.available &&
      findAvailableVariant(currentSelect, selectedOptions, !1, !0, !0)
    )
      return;
    currentSelect.dataset.selectedId = selectedVariant.id;
    const selectIndex = currentSelect.dataset.selectIndex,
      selectedLabel = currentSelect.closest(".quantity-break"),
      selectInput = selectedLabel.dataset.input;
    if (
      ((this.selectedVariants[selectInput][selectIndex] = selectedVariant.id),
      (this.formVariants = this.selectedVariants[selectInput]),
      this.updateMedia(selectedVariant),
      !this.updatePrices)
    )
      return;
    var totalPrice = 0,
      totalComparePrice = 0;
    const quantity = parseFloat(selectedLabel.dataset.quantity),
      percentageLeft = parseFloat(selectedLabel.dataset.percentageLeft),
      fixedDiscount = parseFloat(selectedLabel.dataset.fixedDiscount);
    for (let i = 0; i < quantity; i++) {
      const currentId = parseInt(this.selectedVariants[selectInput][i]),
        currentVariant = this.getVariantData().find(
          (v) => parseInt(v.id) === currentId
        );
      if (!currentVariant) return;
      (totalPrice += currentVariant.price),
        currentVariant.compare_at_price &&
        currentVariant.compare_at_price > currentVariant.price
          ? (totalComparePrice += currentVariant.compare_at_price)
          : (totalComparePrice += currentVariant.price);
    }
    totalPrice = totalPrice * percentageLeft - fixedDiscount;
    const priceDifference = totalComparePrice - totalPrice,
      priceDifferenceRounded = Math.round(priceDifference / 100) * 100,
      priceEach = totalPrice / quantity,
      comparePriceEach = totalComparePrice / quantity,
      formattedTotalPrice = formatMoney(totalPrice, this.moneyFormat, !0),
      formattedTotalComparePrice = formatMoney(
        totalComparePrice,
        this.moneyFormat,
        !0
      ),
      formattedPriceDifference = formatMoney(
        priceDifference,
        this.moneyFormat,
        !0
      ),
      formattedPriceDifferenceRounded = formatMoney(
        priceDifferenceRounded,
        this.moneyFormat,
        !0
      ),
      formattedPriceEach = formatMoney(priceEach, this.moneyFormat, !0),
      formattedComparePriceEach = formatMoney(
        comparePriceEach,
        this.moneyFormat,
        !0
      );
    selectedLabel
      .querySelectorAll(".variant-price-update")
      .forEach((textElement) => {
        let textValue = textElement.dataset.text;
        (textValue = textValue.replace("[quantity]", quantity)),
          (textValue = textValue.replace("[price]", formattedTotalPrice)),
          (textValue = textValue.replace(
            "[compare_price]",
            formattedTotalComparePrice
          )),
          (textValue = textValue.replace(
            "[amount_saved]",
            formattedPriceDifference
          )),
          (textValue = textValue.replace(
            "[amount_saved_rounded]",
            formattedPriceDifferenceRounded
          )),
          (textValue = textValue.replace("[price_each]", formattedPriceEach)),
          (textValue = textValue.replace(
            "[compare_price_each]",
            formattedComparePriceEach
          )),
          (textElement.innerHTML = textValue);
      });
    const comparePriceElement = selectedLabel.querySelector(
      ".quantity-break__compare-price"
    );
    comparePriceElement &&
      (totalComparePrice > totalPrice
        ? comparePriceElement.classList.remove("hidden")
        : comparePriceElement.classList.add("hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData || JSON.parse(this.jsonData.textContent)),
      this.variantData
    );
  }
  initVariants() {
    this.hasVariants &&
      (this.labels.forEach((label) => {
        if (label.querySelector(".quantity-break__variants")) {
          let array = [];
          label
            .querySelectorAll(".quantity-break__selector-item")
            .forEach((select) => {
              array.push(select.dataset.selectedId);
            }),
            (this.selectedVariants[label.dataset.input] = array);
        }
      }),
      (this.formVariants = []));
  }
  updateMedia(selectedVariant) {
    if (!selectedVariant || !selectedVariant.featured_media) return;
    document
      .querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`)
      .forEach((mediaGallery) =>
        mediaGallery.setActiveMedia(
          `${this.dataset.section}-${selectedVariant.featured_media.id}`,
          !0
        )
      );
  }
  handleChange(e) {
    const value = parseInt(e.target.value);
    (this.selectedQuantity = value),
      this.hasVariants &&
        (this.formVariants = this.selectedVariants[e.target.dataset.input]),
      this.quantityGifts && this.quantityGifts.unlockGifts(value);
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
function metafieldPoly() {
  return !0;
}
function updateVariantStatuses(selectedOptionOneVariants, inputWrappers) {
  inputWrappers.forEach((option, index) => {
    if (index === 0) return;
    const optionInputs = [...option.querySelectorAll("option")],
      previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value,
      availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]),
      existentOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) => variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
    optionInputs.forEach((input2) => {
      input2.classList.remove("unavailable", "non-existent"),
        existentOptionInputsValue.includes(input2.getAttribute("value"))
          ? availableOptionInputsValue.includes(input2.getAttribute("value"))
            ? (input2.innerText = input2.getAttribute("value"))
            : ((input2.innerText =
                window.variantStrings.unavailable_with_option.replace(
                  "[value]",
                  input2.getAttribute("value")
                )),
              input2.classList.add("unavailable"))
          : ((input2.innerText =
              window.variantStrings.unavailable_with_option.replace(
                "[value]",
                input2.getAttribute("value")
              )),
            input2.classList.add("non-existent"));
    });
  });
}
function findAvailableVariant(
  container,
  options,
  isMain = !0,
  skipNonExistent = !1,
  skipUnavailable = !1
) {
  for (let i = options.length - 1; i >= 0; i--) {
    const inputWrapper = isMain
        ? container.querySelector(`.product-form__input:nth-child(${i + 1})`)
        : container.querySelectorAll(".select")[i],
      type = isMain
        ? inputWrapper.querySelector(".product-form__input__type").dataset.type
        : "dropdown",
      optionElements =
        type === "dropdown"
          ? inputWrapper.querySelectorAll("option")
          : inputWrapper.querySelectorAll('input[type="radio"]');
    let currentIndex = Array.from(optionElements).findIndex(
        (option) => option.value === options[i]
      ),
      found = !1;
    for (; currentIndex < optionElements.length - 1; ) {
      currentIndex++;
      const nextOption = optionElements[currentIndex];
      if (
        (!skipNonExistent || !nextOption.classList.contains("non-existent")) &&
        (!skipUnavailable || !nextOption.classList.contains("unavailable"))
      ) {
        (options[i] = nextOption.value), (found = !0);
        break;
      }
    }
    if (!found)
      for (
        currentIndex = Array.from(optionElements).findIndex(
          (option) => option.value === options[i]
        );
        currentIndex > 0;

      ) {
        currentIndex--;
        const prevOption = optionElements[currentIndex];
        if (
          (!skipNonExistent ||
            !prevOption.classList.contains("non-existent")) &&
          (!skipUnavailable || !prevOption.classList.contains("unavailable"))
        ) {
          (options[i] = prevOption.value), (found = !0);
          break;
        }
      }
    if (found)
      return (
        type === "dropdown"
          ? (inputWrapper.querySelector(".select__select").value = options[i])
          : (inputWrapper.querySelector(
              `input[type="radio"][value="${options[i]}"]`
            ).checked = !0),
        container.dispatchEvent(new Event("change")),
        !0
      );
  }
  return !1;
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super(),
      (this.gifts = this.querySelectorAll(".quantity-gift")),
      (this.quantityBreaks = document.getElementById(
        `quantity-breaks-${this.dataset.section}`
      )),
      (this.quantitySelector = document.getElementById(
        `Quantity-Form--${this.dataset.section}`
      )),
      (this.unlockedItems = []),
      (this.mainProduct = this.dataset.mainProduct),
      (this.cartItems = document.querySelector("cart-drawer-items")),
      this.initUnlock();
  }
  initUnlock() {
    let initQuantity = 1;
    const mainProductCartItems = this.mainProduct
      ? document.querySelectorAll(`.cart-item--product-${this.mainProduct}`)
      : null;
    if (mainProductCartItems && mainProductCartItems.length) {
      initQuantity = 0;
      for (let i = 0; i < mainProductCartItems.length; i++)
        initQuantity += parseInt(mainProductCartItems[i].dataset.quantity);
    } else if (this.quantityBreaks)
      initQuantity = parseInt(this.quantityBreaks.selectedQuantity);
    else if (this.quantitySelector) {
      const input2 = this.quantitySelector.querySelector(
        'input[name="quantity"]'
      );
      initQuantity = parseInt(input2.value);
    }
    this.unlockGifts(initQuantity, !0);
  }
  unlockGifts(quantity, addRemoveProducts = !1) {
    (this.unlockedItems = []),
      this.gifts.forEach((gift) => {
        if (parseInt(gift.dataset.quantity) <= quantity) {
          gift.classList.add("quantity-gift--unlocked"),
            (gift.dataset.unlocked = "true");
          const cartItem = document.querySelector(
            `.cart-item--product-${gift.dataset.handle}`
          );
          gift.dataset.product &&
            !cartItem &&
            this.unlockedItems.unshift(gift.dataset.product);
        } else
          gift.classList.remove("quantity-gift--unlocked"),
            (gift.dataset.unlocked = "false");
      }),
      this.mainProduct && addRemoveProducts && this.addRemoveProducts();
  }
  addRemoveProducts() {
    if (!this.mainProduct) return;
    const mainProductCartItems = document.querySelectorAll(
      `.cart-item--product-${this.mainProduct}`
    );
    this.gifts.forEach((gift) => {
      mainProductCartItems.length
        ? gift.dataset.unlocked === "true" && gift.dataset.product
          ? this.addToCart(gift)
          : this.removeFromCart(gift)
        : this.removeFromCart(gift);
    });
  }
  addToCart(item) {
    if (document.querySelector(`.cart-item--product-${item.dataset.handle}`))
      return;
    const form = item.querySelector("product-form");
    form && form.handleSubmit();
  }
  removeFromCart(item) {
    const cartItem = document.querySelector(
      `.cart-item--product-${item.dataset.handle}`
    );
    !cartItem ||
      !this.cartItems ||
      this.cartItems.updateQuantity(cartItem.dataset.index, 0);
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super(),
      (this.image = this.querySelector(".upsell__image__img")),
      (this.toggleBtn = this.querySelector(".upsell-toggle-btn")),
      (this.variantSelects = this.querySelector(".upsell__variant-picker")),
      (this.variantSelectElements = this.querySelectorAll(".select__select")),
      (this.jsonData = this.querySelector('[type="application/json"]')),
      (this.productForm = this.querySelector("product-form")),
      this.productForm &&
        (this.idInput = this.productForm.querySelector('[name="id"]')),
      (this.skipNonExistent = this.dataset.skipNonExistent === "true"),
      (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      this.updatePrices &&
        ((this.price = parseInt(this.dataset.price)),
        (this.comparePrice = parseInt(this.dataset.comparePrice)),
        (this.priceSpan = this.querySelector(".upsell__price .regular-price")),
        (this.comparePriceSpan = this.querySelector(
          ".upsell__price .compare-price"
        )),
        (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
        (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
        (this.moneyFormat = this.dataset.moneyFormat),
        (this.isMainOfferItem = this.dataset.mainOfferItem === "true"),
        this.isMainOfferItem &&
          (this.mainOfferContainer = document.querySelector(
            `#MainBundleOffer-${this.dataset.section}`
          ))),
      this.toggleBtn &&
        this.toggleBtn.addEventListener("click", this.handleToggle.bind(this)),
      this.variantSelects &&
        this.variantSelects.addEventListener(
          "change",
          this.handleSelectChange.bind(this)
        );
  }
  handleToggle(e) {
    e.target.nodeName.toLowerCase() === "select" ||
      e.target.nodeName.toLowerCase() === "option" ||
      (this.dataset.selected === "true"
        ? (this.dataset.selected = "false")
        : (this.dataset.selected = "true"));
  }
  handleSelectChange(e) {
    const currentSelect = e.currentTarget,
      selectedOptions = Array.from(
        currentSelect.querySelectorAll("select"),
        (select) => select.value
      ),
      selectedVariant = this.getVariantData().find(
        (variant) =>
          !variant.options
            .map((option, index) => selectedOptions[index] === option)
            .includes(!1)
      ),
      selectedOptionOneVariants = this.getVariantData().filter(
        (variant) =>
          currentSelect.querySelector(":checked").value === variant.option1
      ),
      inputWrappers = [...currentSelect.querySelectorAll("select")];
    if (
      (updateVariantStatuses(selectedOptionOneVariants, inputWrappers),
      !selectedVariant)
    ) {
      this.skipNonExistent &&
        findAvailableVariant(
          currentSelect,
          selectedOptions,
          !1,
          !0,
          this.skipUnavailable
        );
      return;
    }
    (this.skipUnavailable &&
      !selectedVariant.available &&
      findAvailableVariant(currentSelect, selectedOptions, !1, !0, !0)) ||
      (this.updatePrices &&
        ((this.price =
          selectedVariant.price * this.percentageLeft - this.fixedDiscount),
        (this.comparePrice = selectedVariant.price),
        selectedVariant.compare_at_price &&
          selectedVariant.compare_at_price > selectedVariant.price &&
          (this.comparePrice = selectedVariant.compare_at_price),
        displayPrices(
          this.price,
          this.comparePrice,
          this.priceSpan,
          this.comparePriceSpan,
          this.moneyFormat
        )),
      this.image &&
        selectedVariant.featured_image &&
        (this.image.src = selectedVariant.featured_image.src),
      this.updateId(selectedVariant.id),
      this.isMainOfferItem &&
        this.mainOfferContainer.updateTotalPrices &&
        this.mainOfferContainer.updateTotalPrices());
  }
  updateId(id) {
    (this.dataset.id = id), this.idInput && (this.idInput.value = id);
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData || JSON.parse(this.jsonData.textContent)),
      this.variantData
    );
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super(),
      (this.cartDrawer = document.querySelector("cart-drawer")),
      (this.cartItems = this.cartDrawer.querySelector("cart-drawer-items")),
      (this.classicAddButton = this.querySelector(".upsell__add-btn"));
  }
  handleToggle(e) {
    e.target.nodeName.toLowerCase() === "select" ||
      e.target.nodeName.toLowerCase() === "option" ||
      (this.dataset.selected === "true"
        ? ((this.dataset.selected = "false"), this.removeFromCart())
        : ((this.dataset.selected = "true"), this.addToCart()));
  }
  addRemoveFromCart() {
    this.dataset.selected === "true" &&
    !this.cartDrawer.classList.contains("is-empty")
      ? this.addToCart()
      : this.removeFromCart();
  }
  addToCart() {
    this.cartDrawer.querySelector(
      `.cart-item--product-${this.dataset.handle}`
    ) ||
      (this.toggleBtn && this.toggleBtn.setAttribute("disabled", ""),
      this.variantSelectElements.forEach((select) => {
        select.setAttribute("disabled", "");
      }),
      this.productForm.handleSubmit());
  }
  removeFromCart() {
    const cartItem = this.cartDrawer.querySelector(
      `.cart-item--product-${this.dataset.handle}`
    );
    !cartItem ||
      !this.cartItems ||
      (this.toggleBtn && this.toggleBtn.setAttribute("disabled", ""),
      this.variantSelectElements.forEach((select) => {
        select.setAttribute("disabled", "");
      }),
      this.cartItems.updateQuantity(cartItem.dataset.index, 0));
  }
  updateId(id) {
    if (
      ((this.dataset.id = id),
      (this.idInput.value = id),
      !this.classicAddButton && this.dataset.selected === "true")
    ) {
      this.selectTimeout && clearTimeout(this.selectTimeout),
        this.removeFromCart();
      const addToCartListener = (event) => {
        event.detail.handle === "handle" &&
          (this.addToCart(),
          document.removeEventListener(
            "cartQuantityUpdated",
            addToCartListener
          ));
      };
      document.addEventListener("cartQuantityUpdated", addToCartListener);
    }
  }
  getUpdateRequired() {
    const cartItem = this.cartDrawer.querySelector(
      `.cart-item--product-${this.dataset.handle}`
    );
    let updateRequired = !1;
    return (
      ((cartItem && this.dataset.selected === "false") ||
        (!cartItem && this.dataset.selected === "true")) &&
        (updateRequired = !0),
      updateRequired
    );
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(
  price,
  comparePrice,
  priceSpan,
  comparePriceSpan,
  moneyFormat
) {
  if (moneyFormat) {
    if (price && priceSpan) {
      var priceHTML = formatMoney(price, moneyFormat);
      priceSpan.innerHTML = priceHTML;
    }
    if (comparePrice && comparePriceSpan) {
      var comparePriceHTML = formatMoney(comparePrice, moneyFormat);
      (comparePriceSpan.innerHTML = comparePriceHTML),
        comparePrice > price
          ? comparePriceSpan.classList.remove("hidden")
          : comparePriceSpan.classList.add("hidden");
    }
  }
}
function initTrapFocus() {
  return (
    (isIe = !1),
    !(
      document.querySelector("footer") &&
      document.querySelector("footer").dataset.type === null
    )
  );
}
function formatMoney(cents, format, removeTrailingZeros = !1) {
  typeof cents == "string" && (cents = cents.replace(".", ""));
  var value = "",
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format;
  function defaultOption(opt, def) {
    return typeof opt > "u" ? def : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (
      ((precision = defaultOption(precision, 2)),
      (thousands = defaultOption(thousands, ",")),
      (decimal = defaultOption(decimal, ".")),
      isNaN(number) || number == null)
    )
      return 0;
    number = (number / 100).toFixed(precision);
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents2 = parts[1] ? decimal + parts[1] : "";
    return (
      removeTrailingZeros && cents2 === decimal + "00" && (cents2 = ""),
      dollars + cents2
    );
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const cartDrawer = document.querySelector("cart-drawer");
  cartDrawer &&
    cartDrawer
      .querySelectorAll(
        'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift'
      )
      .forEach((upsell) => {
        upsell.addRemoveFromCart && upsell.addRemoveFromCart();
      });
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super(),
      (this.offerItems = this.querySelectorAll(".main-offer-item")),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      this.updatePrices &&
        ((this.priceSpan = this.querySelector(".bundle-deals__total-price-js")),
        (this.comparePriceSpan = this.querySelector(
          ".bundle-deals__total-compare-price-js"
        )),
        (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
        (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
        (this.moneyFormat = this.dataset.moneyFormat));
  }
  updateTotalPrices() {
    if (this.updatePrices) {
      var totalPrice = 0,
        totalComparePrice = 0;
      for (let i = 0; i < this.offerItems.length; i++)
        (totalPrice += parseInt(this.offerItems[i].price)),
          (totalComparePrice += parseInt(this.offerItems[i].comparePrice));
      (totalPrice = totalPrice * this.percentageLeft - this.fixedDiscount),
        displayPrices(
          totalPrice,
          totalComparePrice,
          this.priceSpan,
          this.comparePriceSpan,
          this.moneyFormat
        );
    }
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.fieldName = this.dataset.name),
      (this.input = this.querySelector(
        '[type="text"], [type="number"], textarea'
      )),
      (this.inputRadios = this.querySelectorAll('[type="radio"]')),
      (this.select = this.querySelector(".select__select")),
      (this.productForm = document.getElementById(
        `product-form-${this.dataset.section}`
      )),
      (this.prevValue = this.dataset.defaultValue),
      (this.isRequired = this.dataset.required === "true"),
      (this.isText = !0),
      (this.notMain = this.dataset.notMain === "true"),
      (this.dataset.type === "select" || this.dataset.type === "pills") &&
        (this.isText = !1),
      this.createInputs(),
      this.isRequired &&
        this.isText &&
        ((this.isValid = !0),
        (this.atcButtons = this.notMain
          ? document.querySelectorAll(
              `.featured-product-atc-${this.dataset.section}`
            )
          : document.querySelectorAll(".main-product-atc")),
        (this.mainAtcButton = this.productForm.querySelector(
          `#ProductSubmitButton-${this.dataset.section}`
        )),
        (this.mainAtcBtnLabel =
          this.mainAtcButton.querySelector(".main-atc__label")),
        (this.mainAtcBtnError =
          this.mainAtcButton.querySelector(".main-atc__error")),
        (this.atcErrorMsg = this.dataset.atcErrorMsg),
        (this.mainAtcButton.dataset.requiredFields =
          parseInt(this.mainAtcButton.dataset.requiredFields) + 1),
        (this.mainAtcBtnError.innerHTML = this.atcErrorMsg),
        (this.applyStickyAtcError =
          this.dataset.applyStickyAtcError === "true"),
        (this.stickyAtcButton = document.querySelector(
          `#sticky-atc-${this.dataset.section}`
        )),
        this.applyStickyAtcError &&
          this.stickyAtcButton &&
          ((this.stickyAtcBtnLabel =
            this.stickyAtcButton.querySelector(".sticky-atc__label")),
          (this.stickyAtcBtnError =
            this.stickyAtcButton.querySelector(".sticky-atc__error")),
          (this.stickyAtcBtnError.innerHTML = this.atcErrorMsg)),
        this.validateValue(this.prevValue, null)),
      this.input &&
        this.input.addEventListener("input", this.handleChange.bind(this)),
      this.inputRadios.forEach((input2) => {
        input2.addEventListener("input", this.handleChange.bind(this));
      }),
      this.select &&
        this.select.addEventListener("change", this.handleChange.bind(this));
  }
  handleChange(event) {
    const value = event.target.value.trim();
    if (event.target.checkValidity()) this.prevValue = value;
    else {
      event.target.value = this.prevValue;
      return;
    }
    (this.dataset.value = value),
      (this.productFormInput.value = value),
      this.isRequired && this.isText && this.validateValue(value, event.target);
  }
  validateValue(value, input2) {
    const isValid = value.length > 0;
    if (isValid === this.isValid) return;
    (this.isValid = isValid),
      input2 &&
        (this.isValid
          ? (input2.classList.remove("input--error"),
            (this.mainAtcButton.dataset.validFields =
              parseInt(this.mainAtcButton.dataset.validFields) + 1))
          : (input2.classList.add("input--error"),
            (this.mainAtcButton.dataset.validFields =
              parseInt(this.mainAtcButton.dataset.validFields) - 1)));
    const buttonValid =
        this.mainAtcButton.dataset.validFields ===
        this.mainAtcButton.dataset.requiredFields,
      variantUnavailable = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach((btn) => {
      buttonValid && !variantUnavailable
        ? btn.removeAttribute("disabled")
        : btn.setAttribute("disabled", "");
    }),
      this.atcErrorMsg.length !== 0 &&
        (buttonValid
          ? ((this.mainAtcBtnLabel.style.display = ""),
            (this.mainAtcBtnError.style.display = "none"),
            this.applyStickyAtcError &&
              this.stickyAtcButton &&
              ((this.stickyAtcBtnLabel.style.display = ""),
              (this.stickyAtcBtnError.style.display = "none")))
          : ((this.mainAtcBtnLabel.style.display = "none"),
            (this.mainAtcBtnError.style.display = ""),
            this.applyStickyAtcError &&
              this.stickyAtcButton &&
              ((this.stickyAtcBtnLabel.style.display = "none"),
              (this.stickyAtcBtnError.style.display = ""))));
  }
  createInputs() {
    (this.productFormInput = document.createElement("input")),
      this.productFormInput.setAttribute("type", "hidden"),
      this.productFormInput.setAttribute(
        "name",
        `properties[${this.fieldName}]`
      ),
      (this.productFormInput.value = this.dataset.defaultValue),
      this.productFormInput.classList.add("shrine-property-input"),
      this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    super(),
      (this.secondarySelectSelector = "StickyAtcVariantPicker-"),
      (this.secondarySelect = document.getElementById(
        `${this.secondarySelectSelector}${this.dataset.section}`
      )),
      (this.isSecondary = !1),
      (this.QuantityBreaks = document.getElementById(
        `quantity-breaks-${this.dataset.section}`
      )),
      (this.hasQuantityBreaksPicker =
        this.dataset.hasQuantityBreaksPicker === "true"),
      (this.prependMedia = this.dataset.disablePrepend != "true"),
      (this.filtering = this.dataset.hasFiltering === "true"),
      (this.skipNonExistent = this.dataset.skipNonExistent === "true"),
      (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
      this.hasQuantityBreaksPicker &&
        ((this.quantityBreaksPickerStyle =
          this.dataset.quantityBreaksPickerStyle),
        (this.quantityBreaksPickerDisplayedImages =
          this.dataset.quantityBreaksPickerDisplayedImages)),
      this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    if (
      (this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(!0, "", !1),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.updateVariantStatuses(),
      this.currentVariant)
    ) {
      if (
        this.skipUnavailable &&
        !this.currentVariant.available &&
        findAvailableVariant(this, this.options, !0, !0, !0)
      )
        return;
      this.updateMedia(),
        this.updateURL(),
        this.updateVariantInput(),
        this.renderProductInfo(),
        this.updateShareUrl();
    } else {
      if (
        (this.toggleAddButton(!0, "", !0),
        this.skipNonExistent &&
          findAvailableVariant(
            this,
            this.options,
            !0,
            !0,
            this.skipUnavailable
          ))
      )
        return;
      this.setUnavailable();
    }
  }
  updateOptions() {
    const optionsArr = [];
    this.querySelectorAll(".product-form__input").forEach((input2) => {
      let option;
      const type = input2.querySelector(".product-form__input__type").dataset
        .type;
      type == "dropdown" || type == "dropdwon"
        ? (option = input2.querySelector(".select__select").value)
        : (option = input2.querySelector('input[type="radio"]:checked').value),
        optionsArr.push(option);
    }),
      (this.options = optionsArr);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (variant) =>
        !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(!1)
    );
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    document
      .querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`)
      .forEach((mediaGallery) =>
        mediaGallery.setActiveMedia(
          `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
          this.prependMedia,
          this.filtering,
          this.currentVariant
        )
      );
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }
  updateURL() {
    !this.currentVariant ||
      this.dataset.updateUrl === "false" ||
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    !shareButton ||
      !shareButton.updateUrl ||
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateVariantInput() {
    document
      .querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      )
      .forEach((productForm) => {
        const input2 = productForm.querySelector('input[name="id"]');
        (input2.value = this.currentVariant.id),
          input2.dispatchEvent(new Event("change", { bubbles: !0 }));
      });
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    let inputWrappers;
    this.isSecondary && this.secondarySelect
      ? (inputWrappers = [
          ...this.secondarySelect.querySelectorAll(".product-form__input"),
        ])
      : (inputWrappers = [...this.querySelectorAll(".product-form__input")]),
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [
            ...option.querySelectorAll(
              'input[type="radio"], .select__select option'
            ),
          ],
          previousOptionSelected =
            inputWrappers[index - 1].querySelector(":checked").value,
          availableOptionInputsValue = selectedOptionOneVariants
            .filter(
              (variant) =>
                variant.available &&
                variant[`option${index}`] === previousOptionSelected
            )
            .map((variantOption) => variantOption[`option${index + 1}`]),
          existentOptionInputsValue = selectedOptionOneVariants
            .filter(
              (variant) => variant[`option${index}`] === previousOptionSelected
            )
            .map((variantOption) => variantOption[`option${index + 1}`]);
        this.setInputAvailability(
          optionInputs,
          availableOptionInputsValue,
          existentOptionInputsValue
        );
      });
  }
  setInputAvailability(
    listOfOptions,
    listOfAvailableOptions,
    existentOptionInputsValue
  ) {
    listOfOptions.forEach((input2) => {
      input2.classList.remove("unavailable", "non-existent", "disabled");
      const value = input2.getAttribute("value");
      let swatchInput = null;
      input2.dataset.swatch === "true" &&
        (swatchInput = input2.closest(".color-swatch")),
        swatchInput &&
          swatchInput.classList.remove(
            "unavailable",
            "non-existent",
            "disabled"
          ),
        existentOptionInputsValue.includes(value)
          ? listOfAvailableOptions.includes(value)
            ? input2.nodeName === "OPTION"
              ? (input2.innerText = value)
              : (input2.classList.remove("disabled"),
                swatchInput && swatchInput.classList.remove("disabled"))
            : input2.nodeName === "OPTION"
            ? ((input2.innerText =
                window.variantStrings.unavailable_with_option.replace(
                  "[value]",
                  value
                )),
              input2.classList.add("unavailable"))
            : (input2.classList.add("disabled", "unavailable"),
              swatchInput &&
                swatchInput.classList.add("disabled", "unavailable"))
          : input2.nodeName === "OPTION"
          ? ((input2.innerText =
              window.variantStrings.unavailable_with_option.replace(
                "[value]",
                value
              )),
            input2.classList.add("non-existent"))
          : (input2.classList.add("disabled", "non-existent"),
            swatchInput &&
              swatchInput.classList.add("disabled", "non-existent"));
    });
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    pickUpAvailability &&
      (this.currentVariant && this.currentVariant.available
        ? pickUpAvailability.fetchAvailability &&
          pickUpAvailability.fetchAvailability(this.currentVariant.id)
        : (pickUpAvailability.removeAttribute("available"),
          (pickUpAvailability.innerHTML = "")));
  }
  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;
    const productForm = section.querySelector("product-form");
    productForm && productForm.handleErrorMessage();
  }
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id,
      sectionId = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;
        const html = new DOMParser().parseFromString(responseText, "text/html"),
          destination = document.getElementById(
            `price-${this.dataset.section}`
          ),
          source = html.getElementById(
            `price-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          ),
          stickyAtcSeparatePriceDestination = document.getElementById(
            `sticky-atc-separate-price-${this.dataset.section}`
          ),
          stickyAtcSeparatePriceSource = html.getElementById(
            `sticky-atc-separate-price-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          ),
          stickyAtcPriceDestination = document.getElementById(
            `sticky-atc-price-${this.dataset.section}`
          ),
          stickyAtcPriceSource = html.getElementById(
            `sticky-atc-price-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          ),
          stickyAtcImageDestination = document.getElementById(
            `sticky-atc-image-${this.dataset.section}`
          ),
          stickyAtcImageSource = html.getElementById(
            `sticky-atc-image-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          ),
          mainAtcPriceDestination = document.getElementById(
            `main-atc-price-${this.dataset.section}`
          ),
          mainAtcPriceSource = html.getElementById(
            `main-atc-price-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          ),
          customLabelsDestination = document.querySelectorAll(
            `[id^="custom-label-${this.dataset.section}"]`
          ),
          customLabelsSource = html.querySelectorAll(
            `[id^="custom-label-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }"]`
          ),
          skuSource = html.getElementById(
            `Sku-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          ),
          skuDestination = document.getElementById(
            `Sku-${this.dataset.section}`
          ),
          inventorySource = html.getElementById(
            `Inventory-${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          ),
          inventoryDestination = document.getElementById(
            `Inventory-${this.dataset.section}`
          );
        if (
          (destination && source && (destination.innerHTML = source.innerHTML),
          stickyAtcSeparatePriceDestination &&
            stickyAtcSeparatePriceSource &&
            (stickyAtcSeparatePriceDestination.innerHTML =
              stickyAtcSeparatePriceSource.innerHTML),
          stickyAtcPriceDestination &&
            stickyAtcPriceSource &&
            (stickyAtcPriceDestination.innerHTML =
              stickyAtcPriceSource.innerHTML),
          stickyAtcImageDestination &&
            stickyAtcImageSource &&
            (stickyAtcImageDestination.src = stickyAtcImageSource.src),
          mainAtcPriceSource &&
            mainAtcPriceDestination &&
            (mainAtcPriceDestination.innerHTML = mainAtcPriceSource.innerHTML),
          customLabelsDestination && customLabelsSource)
        )
          for (var i = 0; i < customLabelsDestination.length; i++)
            customLabelsDestination[i].innerHTML =
              customLabelsSource[i].innerHTML;
        if (
          (inventorySource &&
            inventoryDestination &&
            (inventoryDestination.innerHTML = inventorySource.innerHTML),
          skuSource &&
            skuDestination &&
            ((skuDestination.innerHTML = skuSource.innerHTML),
            skuDestination.classList.toggle(
              "visibility-hidden",
              skuSource.classList.contains("visibility-hidden")
            )),
          this.QuantityBreaks)
        ) {
          const quantityBreaksSource = html.getElementById(
              `quantity-breaks-${
                this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section
              }`
            ),
            dynamicPricesDestination =
              this.QuantityBreaks.querySelectorAll(".dynamic-price"),
            dynamicPricesSource =
              quantityBreaksSource.querySelectorAll(".dynamic-price");
          for (let i2 = 0; i2 < dynamicPricesDestination.length; i2++)
            dynamicPricesDestination[i2].innerHTML =
              dynamicPricesSource[i2].innerHTML;
          if (this.QuantityBreaks.hasVariants) {
            this.QuantityBreaks.variantSelects.forEach((select) => {
              select.dataset.selectedId = this.currentVariant.id;
            });
            const quantityBreakSelectsDestination =
                this.QuantityBreaks.querySelectorAll(
                  ".quantity-break__variant-select"
                ),
              quantityBreakSelectsSource =
                quantityBreaksSource.querySelectorAll(
                  ".quantity-break__variant-select"
                );
            for (let i2 = 0; i2 < quantityBreakSelectsDestination.length; i2++)
              quantityBreakSelectsDestination[i2].innerHTML =
                quantityBreakSelectsSource[i2].innerHTML;
            this.QuantityBreaks.initVariants();
          }
        }
        if (this.hasQuantityBreaksPicker) {
          const quantityBreaksSource = html.getElementById(
              `variant-selects-${
                this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section
              }`
            ),
            dynamicPricesDestination = this.querySelectorAll(".dynamic-price"),
            dynamicPricesSource =
              quantityBreaksSource.querySelectorAll(".dynamic-price");
          for (let i2 = 0; i2 < dynamicPricesDestination.length; i2++)
            dynamicPricesDestination[i2].innerHTML =
              dynamicPricesSource[i2].innerHTML;
          if (
            this.quantityBreaksPickerStyle === "vertical" &&
            this.quantityBreaksPickerDisplayedImages === "variant_images"
          ) {
            const dynamicImagesDestination = this.querySelectorAll(
                ".quantity-break__image img"
              ),
              dynamicImagesSource = quantityBreaksSource.querySelectorAll(
                ".quantity-break__image img"
              );
            for (let i2 = 0; i2 < dynamicImagesDestination.length; i2++)
              dynamicImagesDestination[i2].src = dynamicImagesSource[i2].src;
          }
        }
        if (this.secondarySelect) {
          const secondarySelectSource = html.getElementById(
            `${this.secondarySelectSelector}${
              this.dataset.originalSection
                ? this.dataset.originalSection
                : this.dataset.section
            }`
          );
          secondarySelectSource &&
            (this.secondarySelect.innerHTML = secondarySelectSource.innerHTML);
        }
        const price = document.getElementById(`price-${this.dataset.section}`);
        price && price.classList.remove("visibility-hidden"),
          (this.dataset.options = this.currentVariant.options.join(",")),
          inventoryDestination &&
            inventoryDestination.classList.toggle(
              "visibility-hidden",
              inventorySource.innerText === ""
            );
        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : !0,
          window.variantStrings.soldOut
        ),
          publish(PUB_SUB_EVENTS.variantChange, {
            data: { sectionId, html, variant: this.currentVariant },
          });
      });
  }
  toggleAddButton(disable = !0, text, modifyClass = !0) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]'),
      atcButtons = document.querySelectorAll(".main-product-atc");
    var addButtonText = productForm.querySelector(".main-atc__label__text");
    addButtonText ||
      (addButtonText = productForm.querySelector(".main-atc__label"));
    const atcButtonPrice = productForm.querySelector(".main-atc-price");
    addButton &&
      (disable
        ? (addButton.setAttribute("disabled", "disabled"),
          addButton.setAttribute("data-unavailable", "true"),
          text && (addButtonText.textContent = text),
          atcButtons.forEach((btn) => {
            btn.setAttribute("disabled", "disabled");
          }),
          atcButtonPrice && atcButtonPrice.classList.add("hidden"))
        : (addButton.setAttribute("data-unavailable", "false"),
          (addButtonText.textContent = window.variantStrings.addToCart),
          atcButtonPrice && atcButtonPrice.classList.remove("hidden"),
          addButton.dataset.requiredFields === addButton.dataset.validFields &&
            (addButton.removeAttribute("disabled"),
            atcButtons.forEach((btn) => {
              btn.removeAttribute("disabled");
            }))));
  }
  setUnavailable() {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    var addButtonText = productForm.querySelector(".main-atc__label__text");
    addButtonText ||
      (addButtonText = productForm.querySelector(".main-atc__label"));
    const price = document.getElementById(`price-${this.dataset.section}`),
      inventory = document.getElementById(`Inventory-${this.dataset.section}`),
      sku = document.getElementById(`Sku-${this.dataset.section}`);
    addButton &&
      ((addButtonText.textContent = window.variantStrings.unavailable),
      price && price.classList.add("visibility-hidden"),
      inventory && inventory.classList.add("visibility-hidden"),
      sku && sku.classList.add("visibility-hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent
        )),
      this.variantData
    );
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super(),
      (this.secondarySelectSelector = "variant-selects-"),
      (this.secondarySelect = document.getElementById(
        `${this.secondarySelectSelector}${this.dataset.section}`
      )),
      (this.isSecondary = !0);
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super(),
      (this.secondarySelectSelector = "variant-selects-"),
      (this.secondarySelect = document.getElementById(
        `${this.secondarySelectSelector}${this.dataset.section}`
      )),
      (this.isSecondary = !0);
  }
}
customElements.define(
  "secondary-variant-select-separate",
  SecondaryVariantSelectSeparate
);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super(),
      (this.quickAddSubmit = document.getElementById(
        `${this.dataset.section}-submit`
      ));
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(!0, "", !1),
      this.updateVariantStatuses(),
      this.currentVariant
        ? (this.updateMedia(),
          this.updateVariantInput(),
          this.updateQuickAddUrl(),
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          ))
        : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const imageElement = document.getElementById(
      `${this.dataset.section}-image`
    );
    if (!imageElement) return;
    const media = this.currentVariant.featured_media.preview_image,
      baseUrl = media.src.split("?")[0],
      srcset = [165, 360, 533, 720, 940, 1066]
        .filter((width) => media.width >= width)
        .map((width) => `${baseUrl}?width=${width} ${width}w`)
        .join(", ");
    (imageElement.srcset = `${srcset}, ${baseUrl} ${media.width}w`),
      (imageElement.src = `${baseUrl}?width=533`);
  }
  updateQuickAddUrl() {
    !this.currentVariant ||
      !this.quickAddSubmit ||
      (this.quickAddSubmit.dataset.productUrl = `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
}
customElements.define("card-variant-selects", CardVariantSelects);
//# sourceMappingURL=/cdn/shop/t/13/assets/main.js.map?v=108298661489043041841741565356%3Fversion%3D1
